"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Freight Pay/Audit
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.3.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountingBillsApi = exports.AccountingBillsApiFactory = exports.AccountingBillsApiFp = exports.AccountingBillsApiAxiosParamCreator = exports.V2ChargeCategory = exports.UpdateDisableInvoiceStatusesDetailsRuleTypeEnum = exports.UpdateAutoGenerateInvoiceDetailsRuleTypeEnum = exports.UpdateAutoDisputeInvoiceDetailsRuleTypeEnum = exports.UpdateAddToDeliveredDashboardActionDetailsRuleTypeEnum = exports.ScheduledAccountingBillSuccessProcessingStatusEnum = exports.ScheduledAccountingBillProcessingProcessingStatusEnum = exports.ScheduledAccountingBillErrorProcessingStatusEnum = exports.RoleType = exports.ProductLineItemWeightUnit = exports.ProductLineItemPackagingType = exports.ProcessingStatus = exports.PaymentEntityType = exports.LengthUnit = exports.InvoiceableType = exports.InvoiceableReferenceType = exports.InvoiceRuleConfigurationType = exports.GeneratedBy = exports.FreightStopReason = exports.FreightSettlementsConfigurationType = exports.FreightInvoiceSubStatusType = exports.FreightInvoiceStatus = exports.FreightInvoiceSource = exports.FreightInvoicePendingStatus = exports.FreightInvoiceIncludeOptions = exports.FreightInvoiceExcludeRelatedEntitiesOptions = exports.FreightInvoiceCarrierStatus = exports.FreightClass = exports.FPMInvoiceableStatus = exports.DocumentType = exports.CustomerReferenceResourceTypeEnum = exports.ChargeLineItemQuantityUnitType = exports.ChargeCategory = exports.AvailableInvoiceStatuses = exports.AmountToleranceLimitType = exports.AmountToleranceBoundaryType = exports.AccountingInvoiceableType = exports.AccountingInvoiceReferenceResourceTypeEnum = exports.AccountingInvoiceProcessSuccessProcessingStatusEnum = exports.AccountingInvoiceProcessErrorProcessingStatusEnum = exports.AccountingInvoiceResourceTypeEnum = exports.AccountingBillableType = exports.AccountingBillReferenceResourceTypeEnum = exports.AccountingBillProcessSuccessProcessingStatusEnum = exports.AccountingBillProcessErrorProcessingStatusEnum = exports.AccountingBillResourceTypeEnum = void 0;
exports.QuickbooksApi = exports.QuickbooksApiFactory = exports.QuickbooksApiFp = exports.QuickbooksApiAxiosParamCreator = exports.FreightSettlementsConfigurationsApi = exports.FreightSettlementsConfigurationsApiFactory = exports.FreightSettlementsConfigurationsApiFp = exports.FreightSettlementsConfigurationsApiAxiosParamCreator = exports.FreightInvoicesApi = exports.FreightInvoicesApiFactory = exports.FreightInvoicesApiFp = exports.FreightInvoicesApiAxiosParamCreator = exports.FPMInvoiceRuleConfigurationsApi = exports.FPMInvoiceRuleConfigurationsApiFactory = exports.FPMInvoiceRuleConfigurationsApiFp = exports.FPMInvoiceRuleConfigurationsApiAxiosParamCreator = exports.DefaultApi = exports.DefaultApiFactory = exports.DefaultApiFp = exports.DefaultApiAxiosParamCreator = exports.AccountingInvoicesApi = exports.AccountingInvoicesApiFactory = exports.AccountingInvoicesApiFp = exports.AccountingInvoicesApiAxiosParamCreator = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
exports.AccountingBillResourceTypeEnum = {
    Bill: 'bill'
};
exports.AccountingBillProcessErrorProcessingStatusEnum = {
    Error: 'ERROR'
};
exports.AccountingBillProcessSuccessProcessingStatusEnum = {
    Success: 'SUCCESS'
};
exports.AccountingBillReferenceResourceTypeEnum = {
    AccountingBill: 'accounting_bill'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.AccountingBillableType = {
    TransportationOrder: 'TRANSPORTATION_ORDER',
    V2Shipment: 'V2_SHIPMENT'
};
exports.AccountingInvoiceResourceTypeEnum = {
    AccountingInvoice: 'accounting_invoice'
};
exports.AccountingInvoiceProcessErrorProcessingStatusEnum = {
    Error: 'ERROR'
};
exports.AccountingInvoiceProcessSuccessProcessingStatusEnum = {
    Success: 'SUCCESS'
};
exports.AccountingInvoiceReferenceResourceTypeEnum = {
    AccountingInvoice: 'accounting_invoice'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.AccountingInvoiceableType = {
    TransportationOrder: 'TRANSPORTATION_ORDER',
    V2Shipment: 'V2_SHIPMENT'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.AmountToleranceBoundaryType = {
    Floor: 'FLOOR',
    Ceiling: 'CEILING'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.AmountToleranceLimitType = {
    MonetaryAmount: 'MONETARY_AMOUNT',
    Percentage: 'PERCENTAGE'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.AvailableInvoiceStatuses = {
    Disputed: 'DISPUTED',
    Passed: 'PASSED',
    Approved: 'APPROVED',
    Scheduled: 'SCHEDULED',
    Paid: 'PAID',
    Rejected: 'REJECTED'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.ChargeCategory = {
    LineHaul: 'LINE_HAUL',
    Fuel: 'FUEL',
    FuelSurcharge: 'FUEL_SURCHARGE',
    Accessorial: 'ACCESSORIAL',
    Tax: 'TAX',
    Insurance: 'INSURANCE',
    Detention: 'DETENTION',
    Other: 'OTHER',
    ServiceFee: 'SERVICE_FEE',
    Adjustment: 'ADJUSTMENT',
    Tonu: 'TONU',
    Variance: 'VARIANCE',
    Teamdrivers: 'TEAMDRIVERS',
    Layover: 'LAYOVER'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.ChargeLineItemQuantityUnitType = {
    Barrel: 'BARREL',
    Box: 'BOX',
    Each: 'EACH',
    Gallon: 'GALLON',
    Kilogram: 'KILOGRAM',
    Liter: 'LITER',
    Mile: 'MILE',
    Piece: 'PIECE',
    Pound: 'POUND',
    FlatRate: 'FLAT_RATE'
};
exports.CustomerReferenceResourceTypeEnum = {
    Customer: 'customer'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.DocumentType = {
    Bol: 'BOL',
    Fuel: 'FUEL',
    Lumper: 'LUMPER',
    Hos: 'HOS',
    Signature: 'SIGNATURE',
    RateConfirmation: 'RATE_CONFIRMATION',
    CustomerTender: 'CUSTOMER_TENDER',
    DeliveryReceipt: 'DELIVERY_RECEIPT',
    WeightCertificate: 'WEIGHT_CERTIFICATE',
    OveragesShortagesAndDamages: 'OVERAGES_SHORTAGES_AND_DAMAGES',
    RenditionInvoicePacket: 'RENDITION_INVOICE_PACKET',
    InventoryRelease: 'INVENTORY_RELEASE',
    Invoice: 'INVOICE',
    Insurance: 'INSURANCE',
    ShippingLabel: 'SHIPPING_LABEL',
    CustomsPaperwork: 'CUSTOMS_PAPERWORK',
    PackingSlips: 'PACKING_SLIPS',
    CarrierInvoiceOrBillingStatement: 'CARRIER_INVOICE_OR_BILLING_STATEMENT',
    CustomerInvoice: 'CUSTOMER_INVOICE',
    DeliveryOrder: 'DELIVERY_ORDER',
    FactorInvoiceOrBillingStatement: 'FACTOR_INVOICE_OR_BILLING_STATEMENT',
    LetterOfAssignment: 'LETTER_OF_ASSIGNMENT',
    NmfcCertificate: 'NMFC_CERTIFICATE',
    NoticeOfAssignment: 'NOTICE_OF_ASSIGNMENT',
    NoticeOfRelease: 'NOTICE_OF_RELEASE',
    PackingSlip: 'PACKING_SLIP',
    AdvanceRequest: 'ADVANCE_REQUEST',
    DriverForm: 'DRIVER_FORM',
    TollReceipt: 'TOLL_RECEIPT',
    ExitPass: 'EXIT_PASS',
    WashReceipt: 'WASH_RECEIPT',
    DetentionApproval: 'DETENTION_APPROVAL',
    Fine: 'FINE',
    W9: 'W9',
    Authority: 'AUTHORITY',
    Claim: 'CLAIM',
    Comcheck: 'COMCHECK',
    MasterBillOfLading: 'MASTER_BILL_OF_LADING',
    HouseBillOfLading: 'HOUSE_BILL_OF_LADING',
    Waybill: 'WAYBILL',
    CommercialInvoice: 'COMMERCIAL_INVOICE',
    CertificateOfOrigin: 'CERTIFICATE_OF_ORIGIN',
    InspectionCertificate: 'INSPECTION_CERTIFICATE',
    WeightTicketUnloaded: 'WEIGHT_TICKET_UNLOADED',
    PalletReceipt: 'PALLET_RECEIPT',
    HouseAirwayBill: 'HOUSE_AIRWAY_BILL',
    MasterAirwayBill: 'MASTER_AIRWAY_BILL',
    CustomsClearanceRequest: 'CUSTOMS_CLEARANCE_REQUEST',
    CustomsEntrySummary: 'CUSTOMS_ENTRY_SUMMARY',
    Other: 'OTHER',
    LumperCertificate: 'LUMPER_CERTIFICATE',
    LetterOfAuthorization: 'LETTER_OF_AUTHORIZATION'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FPMInvoiceableStatus = {
    Delivered: 'DELIVERED',
    Reconciled: 'RECONCILED'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FreightClass = {
    _50: '50',
    _55: '55',
    _60: '60',
    _65: '65',
    _70: '70',
    _775: '77.5',
    _85: '85',
    _925: '92.5',
    _100: '100',
    _110: '110',
    _125: '125',
    _150: '150',
    _175: '175',
    _200: '200',
    _250: '250',
    _300: '300',
    _400: '400',
    _500: '500'
};
/**
 * A service provider will not see if an invoice is in RECEIVED, PASSED, EXCEPTION, or APPROVED. REVIEWING: the invoice is being reviewed by the booking party.
 * @export
 * @enum {string}
 */
exports.FreightInvoiceCarrierStatus = {
    Reviewing: 'REVIEWING'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FreightInvoiceExcludeRelatedEntitiesOptions = {
    Stops: 'stops',
    ChargeLineItems: 'charge_line_items',
    ProductLineItems: 'product_line_items',
    BillTo: 'bill_to',
    SubStatuses: 'sub_statuses'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FreightInvoiceIncludeOptions = {
    ProcessedTotal: 'processed_total',
    TotalPassed: 'total_passed'
};
/**
 * PENDING: If FPM is currently being ran on this invoice
 * @export
 * @enum {string}
 */
exports.FreightInvoicePendingStatus = {
    Pending: 'PENDING'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FreightInvoiceSource = {
    CarrierGenerated: 'CARRIER_GENERATED',
    Edi210: 'EDI_210',
    Dfm: 'DFM',
    ShipwellWeb: 'SHIPWELL_WEB',
    UploadedInvoice: 'UPLOADED_INVOICE'
};
/**
 * RECEIVED: default status for all new freight invoices. PASSED: invoice has gone through validation process and succeeded based on thresholds. EXCEPTION: invoice failed validation based on thresholds. See exception sub-statuses field for details. APPROVED: invoice has been accepted by booking party with intent of payment. SCHEDULED: invoice is in process of payment, likely via 3rd-party. PAID: booking party has sent payment for the invoice. VOIDED: invoice has been cancelled by service provider. REJECTED: invoice has been rejected by booking party. DISPUTED: invoice is being disputed by booking party. RESOLVED: disputed invoice is resolved either by booking party or by service provider.
 * @export
 * @enum {string}
 */
exports.FreightInvoiceStatus = {
    Received: 'RECEIVED',
    Passed: 'PASSED',
    Exception: 'EXCEPTION',
    Approved: 'APPROVED',
    Scheduled: 'SCHEDULED',
    Paid: 'PAID',
    Voided: 'VOIDED',
    Rejected: 'REJECTED',
    Disputed: 'DISPUTED',
    Resolved: 'RESOLVED'
};
/**
 * Not delivered: This represents an invoice received for a shipment leg where it has not been delivered.  Wrong party: This represents any invoice that during First Pass Match has been identified as a party requesting payment that does not appear to be a party warranting payment for a shipment. For example, a carrier takes the original shipment and subs it out to another carrier but the original carrier is requesting payment.  Wrong amount: This represents any invoice that during First Pass Match has been: 1) identified to be the wrong amount per the agreed upon financials; and 2) the difference is outside of customer determined thresholds (above or below).  Already paid: This represents any invoice that during First Pass Match has been identified as the shipment leg for the party already scheduled to be paid or paid.  Missing POD: {DEPRECATED IN FAVOR OF: [MISSING_DOC]} This represents any invoice that during First Pass Match has been identified as the shipment leg does not have satisfactory proof of delivery and under Customer Threshold it has the requirement of a proof of delivery present. [For initial effort here we plan on allowing for parties to mark whether a shipment leg has satisfactory Proof of Delivery although in the future we plan on allowing for an automated review to identify if a Proof of Delivery has been provided].  Missing Doc: This represents any invoice that during First Pass Match has been identified as missing one or more documents of the type that is required by the Customer Thresholds for the booking party. Multiple instances of this exception type can exist on a shipment, and the description field will clarify what document type is missing  Not matched: This represents any invoice received but is not matched to a shipment leg within Shipwell.  No Shipment Financials: This occurs when the shipment does not have any charge line items or a total to compare financials against.  Other: This represents other exceptions that may arise that are uncertain at this time.
 * @export
 * @enum {string}
 */
exports.FreightInvoiceSubStatusType = {
    NotDelivered: 'NOT_DELIVERED',
    WrongParty: 'WRONG_PARTY',
    WrongAmount: 'WRONG_AMOUNT',
    AlreadyPaid: 'ALREADY_PAID',
    MissingPod: 'MISSING_POD',
    NotMatched: 'NOT_MATCHED',
    MissingDoc: 'MISSING_DOC',
    NoShipmentFinancials: 'NO_SHIPMENT_FINANCIALS',
    Other: 'OTHER'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FreightSettlementsConfigurationType = {
    AddToDeliveredDashboard: 'ADD_TO_DELIVERED_DASHBOARD',
    AutoGenerateInvoice: 'AUTO_GENERATE_INVOICE',
    AutoDisputeInvoice: 'AUTO_DISPUTE_INVOICE',
    DisableInvoiceStatus: 'DISABLE_INVOICE_STATUS'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FreightStopReason = {
    Load: 'LOAD',
    Unload: 'UNLOAD'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.GeneratedBy = {
    ServiceProvider: 'SERVICE_PROVIDER',
    BookingParty: 'BOOKING_PARTY'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.InvoiceRuleConfigurationType = {
    DocumentRequired: 'DOCUMENT_REQUIRED',
    FinancialsThreshold: 'FINANCIALS_THRESHOLD',
    DocumentsRequired: 'DOCUMENTS_REQUIRED',
    ServiceProviderNameMatch: 'SERVICE_PROVIDER_NAME_MATCH',
    InvoiceableStatus: 'INVOICEABLE_STATUS',
    MultipleInvoicesPerInvoiceable: 'MULTIPLE_INVOICES_PER_INVOICEABLE'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.InvoiceableReferenceType = {
    PoNumber: 'PO_NUMBER',
    BolNumber: 'BOL_NUMBER',
    PickupNumber: 'PICKUP_NUMBER',
    CustomerReferenceNumber: 'CUSTOMER_REFERENCE_NUMBER'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.InvoiceableType = {
    TransportationOrder: 'TRANSPORTATION_ORDER',
    V2Shipment: 'V2_SHIPMENT'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.LengthUnit = {
    Cm: 'CM',
    Ft: 'FT',
    In: 'IN',
    M: 'M'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.PaymentEntityType = {
    Individual: 'INDIVIDUAL',
    Company: 'COMPANY'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.ProcessingStatus = {
    Processing: 'PROCESSING',
    Success: 'SUCCESS',
    Error: 'ERROR'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.ProductLineItemPackagingType = {
    Bag: 'BAG',
    Bale: 'BALE',
    Bin: 'BIN',
    Bottle: 'BOTTLE',
    Box: 'BOX',
    Bucket: 'BUCKET',
    Pail: 'PAIL',
    Bundle: 'BUNDLE',
    Can: 'CAN',
    Carton: 'CARTON',
    Case: 'CASE',
    Coil: 'COIL',
    Crate: 'CRATE',
    Cylinder: 'CYLINDER',
    Drum: 'DRUM',
    Jerrican: 'JERRICAN',
    Package: 'PACKAGE',
    Pieces: 'PIECES',
    Reel: 'REEL',
    Roll: 'ROLL',
    Skid: 'SKID',
    Tube: 'TUBE',
    Container: 'CONTAINER',
    Barrel: 'BARREL',
    Basket: 'BASKET',
    Envelope: 'ENVELOPE',
    Hamper: 'HAMPER',
    None: 'NONE',
    Other: 'OTHER',
    Pallet: 'PALLET',
    Piece: 'PIECE',
    Tank: 'TANK',
    ToteBin: 'TOTE_BIN',
    ToteCan: 'TOTE_CAN',
    FloorLoaded: 'FLOOR_LOADED',
    Unit: 'UNIT'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.ProductLineItemWeightUnit = {
    Lb: 'LB',
    Kg: 'KG'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.RoleType = {
    ServiceProvider: 'SERVICE_PROVIDER',
    BookingParty: 'BOOKING_PARTY'
};
exports.ScheduledAccountingBillErrorProcessingStatusEnum = {
    Error: 'ERROR'
};
exports.ScheduledAccountingBillProcessingProcessingStatusEnum = {
    Processing: 'PROCESSING'
};
exports.ScheduledAccountingBillSuccessProcessingStatusEnum = {
    Success: 'SUCCESS'
};
exports.UpdateAddToDeliveredDashboardActionDetailsRuleTypeEnum = {
    AddToDeliveredDashboard: 'ADD_TO_DELIVERED_DASHBOARD'
};
exports.UpdateAutoDisputeInvoiceDetailsRuleTypeEnum = {
    AutoDisputeInvoice: 'AUTO_DISPUTE_INVOICE'
};
exports.UpdateAutoGenerateInvoiceDetailsRuleTypeEnum = {
    AutoGenerateInvoice: 'AUTO_GENERATE_INVOICE'
};
exports.UpdateDisableInvoiceStatusesDetailsRuleTypeEnum = {
    DisableInvoiceStatus: 'DISABLE_INVOICE_STATUS'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.V2ChargeCategory = {
    Lh: 'LH',
    Fsc: 'FSC',
    Acc: 'ACC',
    Sf: 'SF'
};
/**
 * AccountingBillsApi - axios parameter creator
 * @export
 */
var AccountingBillsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Creating a Bill kicks off an asynchronous request to create the Bill in an external Financial Management System (FMS) which serves as the system of record for the Bill.  TODO: should we store some sort of generic bag of \'references\' like shipment reference number, order reference number, etc
         * @summary Create Accounting Bill
         * @param {CreateAccountingBill} data
         * @param {Array<File>} [documents]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountingBill: function (data_1, documents_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([data_1, documents_1], args_1, true), void 0, function (data, documents, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('createAccountingBill', 'data', data);
                            localVarPath = "/accounting/bills";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (data !== undefined) {
                                localVarFormParams.append('data', new Blob([JSON.stringify(data)], { type: "application/json", }));
                            }
                            if (documents) {
                                documents.forEach(function (element) {
                                    localVarFormParams.append('documents', element);
                                });
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Accounting Bill
         * @param {string} billId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountingBill: function (billId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([billId_1], args_1, true), void 0, function (billId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'billId' is not null or undefined
                            (0, common_1.assertParamExists)('getAccountingBill', 'billId', billId);
                            localVarPath = "/accounting/bills/{bill_id}"
                                .replace("{".concat("bill_id", "}"), encodeURIComponent(String(billId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * TODO: Should be paginated
         * @summary Get Accounting Bills
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountingBills: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/accounting/bills";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Retrieve all bills that have been scheduled. Scheduled bills may or may not have actually been processed by an integrated Financial Management System.  TODO: what query parameters should this have?  TODO: Should this require a \'billable\' to filter on or allow get all of the scheduled ones?  TODO: Response should be paginated
         * @summary Get Scheduled Accounting Bills
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduledAccountingBills: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/accounting/bills/scheduled";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update a bill based on changes occurring in the Financial Management System
         * @summary Update Integration Accounting Bill
         * @param {string} billId
         * @param {UpdateAccountingBill} updateAccountingBill
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIntegrationAccountingBill: function (billId_1, updateAccountingBill_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([billId_1, updateAccountingBill_1], args_1, true), void 0, function (billId, updateAccountingBill, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'billId' is not null or undefined
                            (0, common_1.assertParamExists)('updateIntegrationAccountingBill', 'billId', billId);
                            // verify required parameter 'updateAccountingBill' is not null or undefined
                            (0, common_1.assertParamExists)('updateIntegrationAccountingBill', 'updateAccountingBill', updateAccountingBill);
                            localVarPath = "/accounting/integrations/bills/{bill_id}"
                                .replace("{".concat("bill_id", "}"), encodeURIComponent(String(billId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateAccountingBill, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Used by the external Financial Management System after processing has completed for a bill. A `ScheduledAccountingBill` can only transition between PROCESSING -> SUCCESS or PROCESSING -> ERROR. Once the transition has occurred, no other updates can be made to the ScheduledAccountingBill. Will return a 409_CONFLICT if an attempt is made to update a `ScheduledAccountingBill` that is not in PROCESSING.
         * @summary Update Scheduled Accounting Bill
         * @param {string} scheduledBillId
         * @param {ScheduledAccountingBillResult} scheduledAccountingBillResult
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScheduledAccountingBill: function (scheduledBillId_1, scheduledAccountingBillResult_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([scheduledBillId_1, scheduledAccountingBillResult_1], args_1, true), void 0, function (scheduledBillId, scheduledAccountingBillResult, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'scheduledBillId' is not null or undefined
                            (0, common_1.assertParamExists)('updateScheduledAccountingBill', 'scheduledBillId', scheduledBillId);
                            // verify required parameter 'scheduledAccountingBillResult' is not null or undefined
                            (0, common_1.assertParamExists)('updateScheduledAccountingBill', 'scheduledAccountingBillResult', scheduledAccountingBillResult);
                            localVarPath = "/accounting/bills/scheduled/{scheduled_bill_id}"
                                .replace("{".concat("scheduled_bill_id", "}"), encodeURIComponent(String(scheduledBillId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(scheduledAccountingBillResult, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.AccountingBillsApiAxiosParamCreator = AccountingBillsApiAxiosParamCreator;
/**
 * AccountingBillsApi - functional programming interface
 * @export
 */
var AccountingBillsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AccountingBillsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Creating a Bill kicks off an asynchronous request to create the Bill in an external Financial Management System (FMS) which serves as the system of record for the Bill.  TODO: should we store some sort of generic bag of \'references\' like shipment reference number, order reference number, etc
         * @summary Create Accounting Bill
         * @param {CreateAccountingBill} data
         * @param {Array<File>} [documents]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountingBill: function (data, documents, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createAccountingBill(data, documents, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountingBillsApi.createAccountingBill']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Accounting Bill
         * @param {string} billId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountingBill: function (billId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAccountingBill(billId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountingBillsApi.getAccountingBill']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * TODO: Should be paginated
         * @summary Get Accounting Bills
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountingBills: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAccountingBills(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountingBillsApi.getAccountingBills']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Retrieve all bills that have been scheduled. Scheduled bills may or may not have actually been processed by an integrated Financial Management System.  TODO: what query parameters should this have?  TODO: Should this require a \'billable\' to filter on or allow get all of the scheduled ones?  TODO: Response should be paginated
         * @summary Get Scheduled Accounting Bills
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduledAccountingBills: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getScheduledAccountingBills(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountingBillsApi.getScheduledAccountingBills']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Update a bill based on changes occurring in the Financial Management System
         * @summary Update Integration Accounting Bill
         * @param {string} billId
         * @param {UpdateAccountingBill} updateAccountingBill
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIntegrationAccountingBill: function (billId, updateAccountingBill, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateIntegrationAccountingBill(billId, updateAccountingBill, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountingBillsApi.updateIntegrationAccountingBill']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Used by the external Financial Management System after processing has completed for a bill. A `ScheduledAccountingBill` can only transition between PROCESSING -> SUCCESS or PROCESSING -> ERROR. Once the transition has occurred, no other updates can be made to the ScheduledAccountingBill. Will return a 409_CONFLICT if an attempt is made to update a `ScheduledAccountingBill` that is not in PROCESSING.
         * @summary Update Scheduled Accounting Bill
         * @param {string} scheduledBillId
         * @param {ScheduledAccountingBillResult} scheduledAccountingBillResult
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScheduledAccountingBill: function (scheduledBillId, scheduledAccountingBillResult, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateScheduledAccountingBill(scheduledBillId, scheduledAccountingBillResult, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountingBillsApi.updateScheduledAccountingBill']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.AccountingBillsApiFp = AccountingBillsApiFp;
/**
 * AccountingBillsApi - factory interface
 * @export
 */
var AccountingBillsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AccountingBillsApiFp)(configuration);
    return {
        /**
         * Creating a Bill kicks off an asynchronous request to create the Bill in an external Financial Management System (FMS) which serves as the system of record for the Bill.  TODO: should we store some sort of generic bag of \'references\' like shipment reference number, order reference number, etc
         * @summary Create Accounting Bill
         * @param {AccountingBillsApiCreateAccountingBillRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountingBill: function (requestParameters, options) {
            return localVarFp.createAccountingBill(requestParameters.data, requestParameters.documents, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Accounting Bill
         * @param {AccountingBillsApiGetAccountingBillRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountingBill: function (requestParameters, options) {
            return localVarFp.getAccountingBill(requestParameters.billId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * TODO: Should be paginated
         * @summary Get Accounting Bills
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountingBills: function (options) {
            return localVarFp.getAccountingBills(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieve all bills that have been scheduled. Scheduled bills may or may not have actually been processed by an integrated Financial Management System.  TODO: what query parameters should this have?  TODO: Should this require a \'billable\' to filter on or allow get all of the scheduled ones?  TODO: Response should be paginated
         * @summary Get Scheduled Accounting Bills
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduledAccountingBills: function (options) {
            return localVarFp.getScheduledAccountingBills(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update a bill based on changes occurring in the Financial Management System
         * @summary Update Integration Accounting Bill
         * @param {AccountingBillsApiUpdateIntegrationAccountingBillRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIntegrationAccountingBill: function (requestParameters, options) {
            return localVarFp.updateIntegrationAccountingBill(requestParameters.billId, requestParameters.updateAccountingBill, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Used by the external Financial Management System after processing has completed for a bill. A `ScheduledAccountingBill` can only transition between PROCESSING -> SUCCESS or PROCESSING -> ERROR. Once the transition has occurred, no other updates can be made to the ScheduledAccountingBill. Will return a 409_CONFLICT if an attempt is made to update a `ScheduledAccountingBill` that is not in PROCESSING.
         * @summary Update Scheduled Accounting Bill
         * @param {AccountingBillsApiUpdateScheduledAccountingBillRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScheduledAccountingBill: function (requestParameters, options) {
            return localVarFp.updateScheduledAccountingBill(requestParameters.scheduledBillId, requestParameters.scheduledAccountingBillResult, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AccountingBillsApiFactory = AccountingBillsApiFactory;
/**
 * AccountingBillsApi - object-oriented interface
 * @export
 * @class AccountingBillsApi
 * @extends {BaseAPI}
 */
var AccountingBillsApi = /** @class */ (function (_super) {
    __extends(AccountingBillsApi, _super);
    function AccountingBillsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Creating a Bill kicks off an asynchronous request to create the Bill in an external Financial Management System (FMS) which serves as the system of record for the Bill.  TODO: should we store some sort of generic bag of \'references\' like shipment reference number, order reference number, etc
     * @summary Create Accounting Bill
     * @param {AccountingBillsApiCreateAccountingBillRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingBillsApi
     */
    AccountingBillsApi.prototype.createAccountingBill = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AccountingBillsApiFp)(this.configuration).createAccountingBill(requestParameters.data, requestParameters.documents, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Accounting Bill
     * @param {AccountingBillsApiGetAccountingBillRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingBillsApi
     */
    AccountingBillsApi.prototype.getAccountingBill = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AccountingBillsApiFp)(this.configuration).getAccountingBill(requestParameters.billId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * TODO: Should be paginated
     * @summary Get Accounting Bills
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingBillsApi
     */
    AccountingBillsApi.prototype.getAccountingBills = function (options) {
        var _this = this;
        return (0, exports.AccountingBillsApiFp)(this.configuration).getAccountingBills(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieve all bills that have been scheduled. Scheduled bills may or may not have actually been processed by an integrated Financial Management System.  TODO: what query parameters should this have?  TODO: Should this require a \'billable\' to filter on or allow get all of the scheduled ones?  TODO: Response should be paginated
     * @summary Get Scheduled Accounting Bills
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingBillsApi
     */
    AccountingBillsApi.prototype.getScheduledAccountingBills = function (options) {
        var _this = this;
        return (0, exports.AccountingBillsApiFp)(this.configuration).getScheduledAccountingBills(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update a bill based on changes occurring in the Financial Management System
     * @summary Update Integration Accounting Bill
     * @param {AccountingBillsApiUpdateIntegrationAccountingBillRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingBillsApi
     */
    AccountingBillsApi.prototype.updateIntegrationAccountingBill = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AccountingBillsApiFp)(this.configuration).updateIntegrationAccountingBill(requestParameters.billId, requestParameters.updateAccountingBill, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Used by the external Financial Management System after processing has completed for a bill. A `ScheduledAccountingBill` can only transition between PROCESSING -> SUCCESS or PROCESSING -> ERROR. Once the transition has occurred, no other updates can be made to the ScheduledAccountingBill. Will return a 409_CONFLICT if an attempt is made to update a `ScheduledAccountingBill` that is not in PROCESSING.
     * @summary Update Scheduled Accounting Bill
     * @param {AccountingBillsApiUpdateScheduledAccountingBillRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingBillsApi
     */
    AccountingBillsApi.prototype.updateScheduledAccountingBill = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AccountingBillsApiFp)(this.configuration).updateScheduledAccountingBill(requestParameters.scheduledBillId, requestParameters.scheduledAccountingBillResult, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AccountingBillsApi;
}(base_1.BaseAPI));
exports.AccountingBillsApi = AccountingBillsApi;
/**
 * AccountingInvoicesApi - axios parameter creator
 * @export
 */
var AccountingInvoicesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Creating an AccountingInvoice kicks off an asynchronous request to create the AccountingInvoice in an external Financial Management System (FMS) which serves as the system of record for the AccountingInvoice.  TODO: handle binary data for document uploads  TODO: should we store some sort of generic bag of \'references\' like shipment reference number, order reference number, etc
         * @summary Create Accounting Invoice
         * @param {CreateAccountingInvoice} createAccountingInvoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountingInvoice: function (createAccountingInvoice_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createAccountingInvoice_1], args_1, true), void 0, function (createAccountingInvoice, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createAccountingInvoice' is not null or undefined
                            (0, common_1.assertParamExists)('createAccountingInvoice', 'createAccountingInvoice', createAccountingInvoice);
                            localVarPath = "/accounting/invoices";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createAccountingInvoice, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Emails the invoice and attached documents to the given emails
         * @summary Send Email
         * @param {string} invoiceId
         * @param {EmailAccountingInvoiceRequest} emailAccountingInvoiceRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailAccountingInvoice: function (invoiceId_1, emailAccountingInvoiceRequest_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([invoiceId_1, emailAccountingInvoiceRequest_1], args_1, true), void 0, function (invoiceId, emailAccountingInvoiceRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'invoiceId' is not null or undefined
                            (0, common_1.assertParamExists)('emailAccountingInvoice', 'invoiceId', invoiceId);
                            // verify required parameter 'emailAccountingInvoiceRequest' is not null or undefined
                            (0, common_1.assertParamExists)('emailAccountingInvoice', 'emailAccountingInvoiceRequest', emailAccountingInvoiceRequest);
                            localVarPath = "/accounting/invoices/{invoice_id}/email"
                                .replace("{".concat("invoice_id", "}"), encodeURIComponent(String(invoiceId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(emailAccountingInvoiceRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Accounting Invoice
         * @param {string} invoiceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountingInvoice: function (invoiceId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([invoiceId_1], args_1, true), void 0, function (invoiceId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'invoiceId' is not null or undefined
                            (0, common_1.assertParamExists)('getAccountingInvoice', 'invoiceId', invoiceId);
                            localVarPath = "/accounting/invoices/{invoice_id}"
                                .replace("{".concat("invoice_id", "}"), encodeURIComponent(String(invoiceId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * TODO: Should be paginated
         * @summary Get Accounting Invoices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountingInvoices: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/accounting/invoices";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Retrieve all accounting invoices that have been scheduled. Scheduled accounting invoices may or may not have actually been processed by an integrated Financial Management System.  TODO: what query parameters should this have?  TODO: Should this require an \'invoiceable\' to filter on or allow get all of the scheduled ones?  TODO: Response should be paginated
         * @summary Get Scheduled Accounting Invoices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduledAccountingInvoices: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/accounting/invoices/scheduled";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update an accounting invoice based on changes occurring in the Financial Management System
         * @summary Update Integration Accounting Invoice
         * @param {string} invoiceId
         * @param {UpdateAccountingInvoice} updateAccountingInvoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIntegrationAccountingInvoice: function (invoiceId_1, updateAccountingInvoice_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([invoiceId_1, updateAccountingInvoice_1], args_1, true), void 0, function (invoiceId, updateAccountingInvoice, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'invoiceId' is not null or undefined
                            (0, common_1.assertParamExists)('updateIntegrationAccountingInvoice', 'invoiceId', invoiceId);
                            // verify required parameter 'updateAccountingInvoice' is not null or undefined
                            (0, common_1.assertParamExists)('updateIntegrationAccountingInvoice', 'updateAccountingInvoice', updateAccountingInvoice);
                            localVarPath = "/accounting/integrations/invoices/{invoice_id}"
                                .replace("{".concat("invoice_id", "}"), encodeURIComponent(String(invoiceId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateAccountingInvoice, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Used by the external Financial Management System after processing has completed for an accounting invoice. A `ScheduledAccountingInvoice` can only transition between PROCESSING -> SUCCESS or PROCESSING -> ERROR. Once the transition has occurred, no other updates can be made to the ScheduledAccountingInvoice  TODO: Explicitly document the 4xx that can happen if you try to update a scheduled invoice that     has already transitioned to SUCCESS or ERROR
         * @summary Update Scheduled Accounting Invoice
         * @param {string} scheduledInvoiceId
         * @param {ScheduledAccountingInvoiceResult} scheduledAccountingInvoiceResult
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScheduledAccountingInvoice: function (scheduledInvoiceId_1, scheduledAccountingInvoiceResult_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([scheduledInvoiceId_1, scheduledAccountingInvoiceResult_1], args_1, true), void 0, function (scheduledInvoiceId, scheduledAccountingInvoiceResult, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'scheduledInvoiceId' is not null or undefined
                            (0, common_1.assertParamExists)('updateScheduledAccountingInvoice', 'scheduledInvoiceId', scheduledInvoiceId);
                            // verify required parameter 'scheduledAccountingInvoiceResult' is not null or undefined
                            (0, common_1.assertParamExists)('updateScheduledAccountingInvoice', 'scheduledAccountingInvoiceResult', scheduledAccountingInvoiceResult);
                            localVarPath = "/accounting/invoices/scheduled/{scheduled_invoice_id}"
                                .replace("{".concat("scheduled_invoice_id", "}"), encodeURIComponent(String(scheduledInvoiceId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(scheduledAccountingInvoiceResult, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Void Accounting Invoice
         * @param {string} invoiceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voidAccountingInvoice: function (invoiceId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([invoiceId_1], args_1, true), void 0, function (invoiceId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'invoiceId' is not null or undefined
                            (0, common_1.assertParamExists)('voidAccountingInvoice', 'invoiceId', invoiceId);
                            localVarPath = "/accounting/invoices/{invoice_id}/void"
                                .replace("{".concat("invoice_id", "}"), encodeURIComponent(String(invoiceId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.AccountingInvoicesApiAxiosParamCreator = AccountingInvoicesApiAxiosParamCreator;
/**
 * AccountingInvoicesApi - functional programming interface
 * @export
 */
var AccountingInvoicesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AccountingInvoicesApiAxiosParamCreator)(configuration);
    return {
        /**
         * Creating an AccountingInvoice kicks off an asynchronous request to create the AccountingInvoice in an external Financial Management System (FMS) which serves as the system of record for the AccountingInvoice.  TODO: handle binary data for document uploads  TODO: should we store some sort of generic bag of \'references\' like shipment reference number, order reference number, etc
         * @summary Create Accounting Invoice
         * @param {CreateAccountingInvoice} createAccountingInvoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountingInvoice: function (createAccountingInvoice, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createAccountingInvoice(createAccountingInvoice, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountingInvoicesApi.createAccountingInvoice']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Emails the invoice and attached documents to the given emails
         * @summary Send Email
         * @param {string} invoiceId
         * @param {EmailAccountingInvoiceRequest} emailAccountingInvoiceRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailAccountingInvoice: function (invoiceId, emailAccountingInvoiceRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.emailAccountingInvoice(invoiceId, emailAccountingInvoiceRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountingInvoicesApi.emailAccountingInvoice']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Accounting Invoice
         * @param {string} invoiceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountingInvoice: function (invoiceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAccountingInvoice(invoiceId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountingInvoicesApi.getAccountingInvoice']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * TODO: Should be paginated
         * @summary Get Accounting Invoices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountingInvoices: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAccountingInvoices(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountingInvoicesApi.getAccountingInvoices']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Retrieve all accounting invoices that have been scheduled. Scheduled accounting invoices may or may not have actually been processed by an integrated Financial Management System.  TODO: what query parameters should this have?  TODO: Should this require an \'invoiceable\' to filter on or allow get all of the scheduled ones?  TODO: Response should be paginated
         * @summary Get Scheduled Accounting Invoices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduledAccountingInvoices: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getScheduledAccountingInvoices(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountingInvoicesApi.getScheduledAccountingInvoices']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Update an accounting invoice based on changes occurring in the Financial Management System
         * @summary Update Integration Accounting Invoice
         * @param {string} invoiceId
         * @param {UpdateAccountingInvoice} updateAccountingInvoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIntegrationAccountingInvoice: function (invoiceId, updateAccountingInvoice, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateIntegrationAccountingInvoice(invoiceId, updateAccountingInvoice, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountingInvoicesApi.updateIntegrationAccountingInvoice']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Used by the external Financial Management System after processing has completed for an accounting invoice. A `ScheduledAccountingInvoice` can only transition between PROCESSING -> SUCCESS or PROCESSING -> ERROR. Once the transition has occurred, no other updates can be made to the ScheduledAccountingInvoice  TODO: Explicitly document the 4xx that can happen if you try to update a scheduled invoice that     has already transitioned to SUCCESS or ERROR
         * @summary Update Scheduled Accounting Invoice
         * @param {string} scheduledInvoiceId
         * @param {ScheduledAccountingInvoiceResult} scheduledAccountingInvoiceResult
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScheduledAccountingInvoice: function (scheduledInvoiceId, scheduledAccountingInvoiceResult, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateScheduledAccountingInvoice(scheduledInvoiceId, scheduledAccountingInvoiceResult, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountingInvoicesApi.updateScheduledAccountingInvoice']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Void Accounting Invoice
         * @param {string} invoiceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voidAccountingInvoice: function (invoiceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.voidAccountingInvoice(invoiceId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountingInvoicesApi.voidAccountingInvoice']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.AccountingInvoicesApiFp = AccountingInvoicesApiFp;
/**
 * AccountingInvoicesApi - factory interface
 * @export
 */
var AccountingInvoicesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AccountingInvoicesApiFp)(configuration);
    return {
        /**
         * Creating an AccountingInvoice kicks off an asynchronous request to create the AccountingInvoice in an external Financial Management System (FMS) which serves as the system of record for the AccountingInvoice.  TODO: handle binary data for document uploads  TODO: should we store some sort of generic bag of \'references\' like shipment reference number, order reference number, etc
         * @summary Create Accounting Invoice
         * @param {AccountingInvoicesApiCreateAccountingInvoiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountingInvoice: function (requestParameters, options) {
            return localVarFp.createAccountingInvoice(requestParameters.createAccountingInvoice, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Emails the invoice and attached documents to the given emails
         * @summary Send Email
         * @param {AccountingInvoicesApiEmailAccountingInvoiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailAccountingInvoice: function (requestParameters, options) {
            return localVarFp.emailAccountingInvoice(requestParameters.invoiceId, requestParameters.emailAccountingInvoiceRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Accounting Invoice
         * @param {AccountingInvoicesApiGetAccountingInvoiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountingInvoice: function (requestParameters, options) {
            return localVarFp.getAccountingInvoice(requestParameters.invoiceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * TODO: Should be paginated
         * @summary Get Accounting Invoices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountingInvoices: function (options) {
            return localVarFp.getAccountingInvoices(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieve all accounting invoices that have been scheduled. Scheduled accounting invoices may or may not have actually been processed by an integrated Financial Management System.  TODO: what query parameters should this have?  TODO: Should this require an \'invoiceable\' to filter on or allow get all of the scheduled ones?  TODO: Response should be paginated
         * @summary Get Scheduled Accounting Invoices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduledAccountingInvoices: function (options) {
            return localVarFp.getScheduledAccountingInvoices(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update an accounting invoice based on changes occurring in the Financial Management System
         * @summary Update Integration Accounting Invoice
         * @param {AccountingInvoicesApiUpdateIntegrationAccountingInvoiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIntegrationAccountingInvoice: function (requestParameters, options) {
            return localVarFp.updateIntegrationAccountingInvoice(requestParameters.invoiceId, requestParameters.updateAccountingInvoice, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Used by the external Financial Management System after processing has completed for an accounting invoice. A `ScheduledAccountingInvoice` can only transition between PROCESSING -> SUCCESS or PROCESSING -> ERROR. Once the transition has occurred, no other updates can be made to the ScheduledAccountingInvoice  TODO: Explicitly document the 4xx that can happen if you try to update a scheduled invoice that     has already transitioned to SUCCESS or ERROR
         * @summary Update Scheduled Accounting Invoice
         * @param {AccountingInvoicesApiUpdateScheduledAccountingInvoiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScheduledAccountingInvoice: function (requestParameters, options) {
            return localVarFp.updateScheduledAccountingInvoice(requestParameters.scheduledInvoiceId, requestParameters.scheduledAccountingInvoiceResult, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Void Accounting Invoice
         * @param {AccountingInvoicesApiVoidAccountingInvoiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voidAccountingInvoice: function (requestParameters, options) {
            return localVarFp.voidAccountingInvoice(requestParameters.invoiceId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AccountingInvoicesApiFactory = AccountingInvoicesApiFactory;
/**
 * AccountingInvoicesApi - object-oriented interface
 * @export
 * @class AccountingInvoicesApi
 * @extends {BaseAPI}
 */
var AccountingInvoicesApi = /** @class */ (function (_super) {
    __extends(AccountingInvoicesApi, _super);
    function AccountingInvoicesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Creating an AccountingInvoice kicks off an asynchronous request to create the AccountingInvoice in an external Financial Management System (FMS) which serves as the system of record for the AccountingInvoice.  TODO: handle binary data for document uploads  TODO: should we store some sort of generic bag of \'references\' like shipment reference number, order reference number, etc
     * @summary Create Accounting Invoice
     * @param {AccountingInvoicesApiCreateAccountingInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingInvoicesApi
     */
    AccountingInvoicesApi.prototype.createAccountingInvoice = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AccountingInvoicesApiFp)(this.configuration).createAccountingInvoice(requestParameters.createAccountingInvoice, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Emails the invoice and attached documents to the given emails
     * @summary Send Email
     * @param {AccountingInvoicesApiEmailAccountingInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingInvoicesApi
     */
    AccountingInvoicesApi.prototype.emailAccountingInvoice = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AccountingInvoicesApiFp)(this.configuration).emailAccountingInvoice(requestParameters.invoiceId, requestParameters.emailAccountingInvoiceRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Accounting Invoice
     * @param {AccountingInvoicesApiGetAccountingInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingInvoicesApi
     */
    AccountingInvoicesApi.prototype.getAccountingInvoice = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AccountingInvoicesApiFp)(this.configuration).getAccountingInvoice(requestParameters.invoiceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * TODO: Should be paginated
     * @summary Get Accounting Invoices
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingInvoicesApi
     */
    AccountingInvoicesApi.prototype.getAccountingInvoices = function (options) {
        var _this = this;
        return (0, exports.AccountingInvoicesApiFp)(this.configuration).getAccountingInvoices(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieve all accounting invoices that have been scheduled. Scheduled accounting invoices may or may not have actually been processed by an integrated Financial Management System.  TODO: what query parameters should this have?  TODO: Should this require an \'invoiceable\' to filter on or allow get all of the scheduled ones?  TODO: Response should be paginated
     * @summary Get Scheduled Accounting Invoices
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingInvoicesApi
     */
    AccountingInvoicesApi.prototype.getScheduledAccountingInvoices = function (options) {
        var _this = this;
        return (0, exports.AccountingInvoicesApiFp)(this.configuration).getScheduledAccountingInvoices(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update an accounting invoice based on changes occurring in the Financial Management System
     * @summary Update Integration Accounting Invoice
     * @param {AccountingInvoicesApiUpdateIntegrationAccountingInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingInvoicesApi
     */
    AccountingInvoicesApi.prototype.updateIntegrationAccountingInvoice = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AccountingInvoicesApiFp)(this.configuration).updateIntegrationAccountingInvoice(requestParameters.invoiceId, requestParameters.updateAccountingInvoice, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Used by the external Financial Management System after processing has completed for an accounting invoice. A `ScheduledAccountingInvoice` can only transition between PROCESSING -> SUCCESS or PROCESSING -> ERROR. Once the transition has occurred, no other updates can be made to the ScheduledAccountingInvoice  TODO: Explicitly document the 4xx that can happen if you try to update a scheduled invoice that     has already transitioned to SUCCESS or ERROR
     * @summary Update Scheduled Accounting Invoice
     * @param {AccountingInvoicesApiUpdateScheduledAccountingInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingInvoicesApi
     */
    AccountingInvoicesApi.prototype.updateScheduledAccountingInvoice = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AccountingInvoicesApiFp)(this.configuration).updateScheduledAccountingInvoice(requestParameters.scheduledInvoiceId, requestParameters.scheduledAccountingInvoiceResult, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Void Accounting Invoice
     * @param {AccountingInvoicesApiVoidAccountingInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingInvoicesApi
     */
    AccountingInvoicesApi.prototype.voidAccountingInvoice = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AccountingInvoicesApiFp)(this.configuration).voidAccountingInvoice(requestParameters.invoiceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AccountingInvoicesApi;
}(base_1.BaseAPI));
exports.AccountingInvoicesApi = AccountingInvoicesApi;
/**
 * DefaultApi - axios parameter creator
 * @export
 */
var DefaultApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary List V2 Shipment Freight Invoices
         * @param {string} shipmentId
         * @param {RoleType} [role]
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        listV2ShipmentFreightInvoices: function (shipmentId_1, role_1, page_1, limit_1) {
            var args_1 = [];
            for (var _i = 4; _i < arguments.length; _i++) {
                args_1[_i - 4] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([shipmentId_1, role_1, page_1, limit_1], args_1, true), void 0, function (shipmentId, role, page, limit, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('listV2ShipmentFreightInvoices', 'shipmentId', shipmentId);
                            localVarPath = "/v2/invoicing/shipments/{shipment_id}/freight-invoices"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (role !== undefined) {
                                localVarQueryParameter['role'] = role;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.DefaultApiAxiosParamCreator = DefaultApiAxiosParamCreator;
/**
 * DefaultApi - functional programming interface
 * @export
 */
var DefaultApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DefaultApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary List V2 Shipment Freight Invoices
         * @param {string} shipmentId
         * @param {RoleType} [role]
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        listV2ShipmentFreightInvoices: function (shipmentId, role, page, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listV2ShipmentFreightInvoices(shipmentId, role, page, limit, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.listV2ShipmentFreightInvoices']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.DefaultApiFp = DefaultApiFp;
/**
 * DefaultApi - factory interface
 * @export
 */
var DefaultApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DefaultApiFp)(configuration);
    return {
        /**
         *
         * @summary List V2 Shipment Freight Invoices
         * @param {DefaultApiListV2ShipmentFreightInvoicesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        listV2ShipmentFreightInvoices: function (requestParameters, options) {
            return localVarFp.listV2ShipmentFreightInvoices(requestParameters.shipmentId, requestParameters.role, requestParameters.page, requestParameters.limit, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DefaultApiFactory = DefaultApiFactory;
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
var DefaultApi = /** @class */ (function (_super) {
    __extends(DefaultApi, _super);
    function DefaultApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary List V2 Shipment Freight Invoices
     * @param {DefaultApiListV2ShipmentFreightInvoicesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.listV2ShipmentFreightInvoices = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).listV2ShipmentFreightInvoices(requestParameters.shipmentId, requestParameters.role, requestParameters.page, requestParameters.limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DefaultApi;
}(base_1.BaseAPI));
exports.DefaultApi = DefaultApi;
/**
 * FPMInvoiceRuleConfigurationsApi - axios parameter creator
 * @export
 */
var FPMInvoiceRuleConfigurationsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get Invoice Rule Configuration
         * @param {string} ruleConfigurationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceRuleConfiguration: function (ruleConfigurationId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([ruleConfigurationId_1], args_1, true), void 0, function (ruleConfigurationId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'ruleConfigurationId' is not null or undefined
                            (0, common_1.assertParamExists)('getInvoiceRuleConfiguration', 'ruleConfigurationId', ruleConfigurationId);
                            localVarPath = "/freight-invoices/rule-configurations/{rule_configuration_id}"
                                .replace("{".concat("rule_configuration_id", "}"), encodeURIComponent(String(ruleConfigurationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Invoice Rule Configurations
         * @param {string} [bookingPartyId]
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceRuleConfigurations: function (bookingPartyId_1, page_1, limit_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([bookingPartyId_1, page_1, limit_1], args_1, true), void 0, function (bookingPartyId, page, limit, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/freight-invoices/rule-configurations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (bookingPartyId !== undefined) {
                                localVarQueryParameter['booking_party_id'] = bookingPartyId;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Invoice Rule Configuration
         * @param {string} ruleConfigurationId
         * @param {ConfigDetails} configDetails
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInvoiceRuleConfiguration: function (ruleConfigurationId_1, configDetails_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([ruleConfigurationId_1, configDetails_1], args_1, true), void 0, function (ruleConfigurationId, configDetails, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'ruleConfigurationId' is not null or undefined
                            (0, common_1.assertParamExists)('updateInvoiceRuleConfiguration', 'ruleConfigurationId', ruleConfigurationId);
                            // verify required parameter 'configDetails' is not null or undefined
                            (0, common_1.assertParamExists)('updateInvoiceRuleConfiguration', 'configDetails', configDetails);
                            localVarPath = "/freight-invoices/rule-configurations/{rule_configuration_id}"
                                .replace("{".concat("rule_configuration_id", "}"), encodeURIComponent(String(ruleConfigurationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(configDetails, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * TODO: Should be paginated
         * @summary Update Invoice Rule Configurations Activation Status
         * @param {Array<UpdateInvoiceRuleConfigurationStatus>} updateInvoiceRuleConfigurationStatus
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInvoiceRuleConfigurationsActivationStatus: function (updateInvoiceRuleConfigurationStatus_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([updateInvoiceRuleConfigurationStatus_1], args_1, true), void 0, function (updateInvoiceRuleConfigurationStatus, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'updateInvoiceRuleConfigurationStatus' is not null or undefined
                            (0, common_1.assertParamExists)('updateInvoiceRuleConfigurationsActivationStatus', 'updateInvoiceRuleConfigurationStatus', updateInvoiceRuleConfigurationStatus);
                            localVarPath = "/freight-invoices/rule-configurations/status-update";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateInvoiceRuleConfigurationStatus, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.FPMInvoiceRuleConfigurationsApiAxiosParamCreator = FPMInvoiceRuleConfigurationsApiAxiosParamCreator;
/**
 * FPMInvoiceRuleConfigurationsApi - functional programming interface
 * @export
 */
var FPMInvoiceRuleConfigurationsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.FPMInvoiceRuleConfigurationsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get Invoice Rule Configuration
         * @param {string} ruleConfigurationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceRuleConfiguration: function (ruleConfigurationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getInvoiceRuleConfiguration(ruleConfigurationId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FPMInvoiceRuleConfigurationsApi.getInvoiceRuleConfiguration']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Invoice Rule Configurations
         * @param {string} [bookingPartyId]
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceRuleConfigurations: function (bookingPartyId, page, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getInvoiceRuleConfigurations(bookingPartyId, page, limit, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FPMInvoiceRuleConfigurationsApi.getInvoiceRuleConfigurations']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Invoice Rule Configuration
         * @param {string} ruleConfigurationId
         * @param {ConfigDetails} configDetails
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInvoiceRuleConfiguration: function (ruleConfigurationId, configDetails, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateInvoiceRuleConfiguration(ruleConfigurationId, configDetails, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FPMInvoiceRuleConfigurationsApi.updateInvoiceRuleConfiguration']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * TODO: Should be paginated
         * @summary Update Invoice Rule Configurations Activation Status
         * @param {Array<UpdateInvoiceRuleConfigurationStatus>} updateInvoiceRuleConfigurationStatus
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInvoiceRuleConfigurationsActivationStatus: function (updateInvoiceRuleConfigurationStatus, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateInvoiceRuleConfigurationsActivationStatus(updateInvoiceRuleConfigurationStatus, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FPMInvoiceRuleConfigurationsApi.updateInvoiceRuleConfigurationsActivationStatus']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.FPMInvoiceRuleConfigurationsApiFp = FPMInvoiceRuleConfigurationsApiFp;
/**
 * FPMInvoiceRuleConfigurationsApi - factory interface
 * @export
 */
var FPMInvoiceRuleConfigurationsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.FPMInvoiceRuleConfigurationsApiFp)(configuration);
    return {
        /**
         *
         * @summary Get Invoice Rule Configuration
         * @param {FPMInvoiceRuleConfigurationsApiGetInvoiceRuleConfigurationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceRuleConfiguration: function (requestParameters, options) {
            return localVarFp.getInvoiceRuleConfiguration(requestParameters.ruleConfigurationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Invoice Rule Configurations
         * @param {FPMInvoiceRuleConfigurationsApiGetInvoiceRuleConfigurationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceRuleConfigurations: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.getInvoiceRuleConfigurations(requestParameters.bookingPartyId, requestParameters.page, requestParameters.limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Invoice Rule Configuration
         * @param {FPMInvoiceRuleConfigurationsApiUpdateInvoiceRuleConfigurationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInvoiceRuleConfiguration: function (requestParameters, options) {
            return localVarFp.updateInvoiceRuleConfiguration(requestParameters.ruleConfigurationId, requestParameters.configDetails, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * TODO: Should be paginated
         * @summary Update Invoice Rule Configurations Activation Status
         * @param {FPMInvoiceRuleConfigurationsApiUpdateInvoiceRuleConfigurationsActivationStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInvoiceRuleConfigurationsActivationStatus: function (requestParameters, options) {
            return localVarFp.updateInvoiceRuleConfigurationsActivationStatus(requestParameters.updateInvoiceRuleConfigurationStatus, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.FPMInvoiceRuleConfigurationsApiFactory = FPMInvoiceRuleConfigurationsApiFactory;
/**
 * FPMInvoiceRuleConfigurationsApi - object-oriented interface
 * @export
 * @class FPMInvoiceRuleConfigurationsApi
 * @extends {BaseAPI}
 */
var FPMInvoiceRuleConfigurationsApi = /** @class */ (function (_super) {
    __extends(FPMInvoiceRuleConfigurationsApi, _super);
    function FPMInvoiceRuleConfigurationsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get Invoice Rule Configuration
     * @param {FPMInvoiceRuleConfigurationsApiGetInvoiceRuleConfigurationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FPMInvoiceRuleConfigurationsApi
     */
    FPMInvoiceRuleConfigurationsApi.prototype.getInvoiceRuleConfiguration = function (requestParameters, options) {
        var _this = this;
        return (0, exports.FPMInvoiceRuleConfigurationsApiFp)(this.configuration).getInvoiceRuleConfiguration(requestParameters.ruleConfigurationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Invoice Rule Configurations
     * @param {FPMInvoiceRuleConfigurationsApiGetInvoiceRuleConfigurationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FPMInvoiceRuleConfigurationsApi
     */
    FPMInvoiceRuleConfigurationsApi.prototype.getInvoiceRuleConfigurations = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.FPMInvoiceRuleConfigurationsApiFp)(this.configuration).getInvoiceRuleConfigurations(requestParameters.bookingPartyId, requestParameters.page, requestParameters.limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Invoice Rule Configuration
     * @param {FPMInvoiceRuleConfigurationsApiUpdateInvoiceRuleConfigurationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FPMInvoiceRuleConfigurationsApi
     */
    FPMInvoiceRuleConfigurationsApi.prototype.updateInvoiceRuleConfiguration = function (requestParameters, options) {
        var _this = this;
        return (0, exports.FPMInvoiceRuleConfigurationsApiFp)(this.configuration).updateInvoiceRuleConfiguration(requestParameters.ruleConfigurationId, requestParameters.configDetails, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * TODO: Should be paginated
     * @summary Update Invoice Rule Configurations Activation Status
     * @param {FPMInvoiceRuleConfigurationsApiUpdateInvoiceRuleConfigurationsActivationStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FPMInvoiceRuleConfigurationsApi
     */
    FPMInvoiceRuleConfigurationsApi.prototype.updateInvoiceRuleConfigurationsActivationStatus = function (requestParameters, options) {
        var _this = this;
        return (0, exports.FPMInvoiceRuleConfigurationsApiFp)(this.configuration).updateInvoiceRuleConfigurationsActivationStatus(requestParameters.updateInvoiceRuleConfigurationStatus, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return FPMInvoiceRuleConfigurationsApi;
}(base_1.BaseAPI));
exports.FPMInvoiceRuleConfigurationsApi = FPMInvoiceRuleConfigurationsApi;
/**
 * FreightInvoicesApi - axios parameter creator
 * @export
 */
var FreightInvoicesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Create Freight Invoice
         * @param {CreateFreightInvoice} data
         * @param {CreateFreightInvoiceDocument} [documentsMetadata]
         * @param {Array<File>} [documents]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFreightInvoice: function (data_1, documentsMetadata_1, documents_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([data_1, documentsMetadata_1, documents_1], args_1, true), void 0, function (data, documentsMetadata, documents, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('createFreightInvoice', 'data', data);
                            localVarPath = "/freight-invoices";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (data !== undefined) {
                                localVarFormParams.append('data', new Blob([JSON.stringify(data)], { type: "application/json", }));
                            }
                            if (documentsMetadata !== undefined) {
                                localVarFormParams.append('documents_metadata', new Blob([JSON.stringify(documentsMetadata)], { type: "application/json", }));
                            }
                            if (documents) {
                                documents.forEach(function (element) {
                                    localVarFormParams.append('documents', element);
                                });
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Freight Invoice
         * @param {CreateFreightInvoice} data
         * @param {CreateFreightInvoiceDocument} [documentsMetadata]
         * @param {Array<File>} [documents]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        createFreightInvoiceDeprecated: function (data_1, documentsMetadata_1, documents_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([data_1, documentsMetadata_1, documents_1], args_1, true), void 0, function (data, documentsMetadata, documents, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('createFreightInvoiceDeprecated', 'data', data);
                            localVarPath = "/freight/invoices";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (data !== undefined) {
                                localVarFormParams.append('data', new Blob([JSON.stringify(data)], { type: "application/json", }));
                            }
                            if (documentsMetadata !== undefined) {
                                localVarFormParams.append('documents_metadata', new Blob([JSON.stringify(documentsMetadata)], { type: "application/json", }));
                            }
                            if (documents) {
                                documents.forEach(function (element) {
                                    localVarFormParams.append('documents', element);
                                });
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create or attach one or more Freight Invoice Documents to an existing Freight Invoice. Navigate to      [this guide](/docs/shipments/freight-invoices/) to learn how to create a Freight Invoice from a Shipment.
         * @summary Create Freight Invoice Document
         * @param {string} invoiceId
         * @param {CreateFreightInvoiceDocument} [documentsMetadata]
         * @param {Array<File>} [documents]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFreightInvoiceDocument: function (invoiceId_1, documentsMetadata_1, documents_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([invoiceId_1, documentsMetadata_1, documents_1], args_1, true), void 0, function (invoiceId, documentsMetadata, documents, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'invoiceId' is not null or undefined
                            (0, common_1.assertParamExists)('createFreightInvoiceDocument', 'invoiceId', invoiceId);
                            localVarPath = "/freight-invoices/{invoice_id}/documents"
                                .replace("{".concat("invoice_id", "}"), encodeURIComponent(String(invoiceId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (documentsMetadata !== undefined) {
                                localVarFormParams.append('documents_metadata', new Blob([JSON.stringify(documentsMetadata)], { type: "application/json", }));
                            }
                            if (documents) {
                                documents.forEach(function (element) {
                                    localVarFormParams.append('documents', element);
                                });
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Freight Invoice
         * @param {string} invoiceId
         * @param {Array<FreightInvoiceIncludeOptions>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreightInvoice: function (invoiceId_1, include_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([invoiceId_1, include_1], args_1, true), void 0, function (invoiceId, include, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'invoiceId' is not null or undefined
                            (0, common_1.assertParamExists)('getFreightInvoice', 'invoiceId', invoiceId);
                            localVarPath = "/freight-invoices/{invoice_id}"
                                .replace("{".concat("invoice_id", "}"), encodeURIComponent(String(invoiceId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (include) {
                                localVarQueryParameter['include'] = include;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Freight Invoice
         * @param {string} invoiceId
         * @param {Array<FreightInvoiceIncludeOptions>} [include]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getFreightInvoiceDeprecated: function (invoiceId_1, include_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([invoiceId_1, include_1], args_1, true), void 0, function (invoiceId, include, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'invoiceId' is not null or undefined
                            (0, common_1.assertParamExists)('getFreightInvoiceDeprecated', 'invoiceId', invoiceId);
                            localVarPath = "/freight/invoices/{invoice_id}"
                                .replace("{".concat("invoice_id", "}"), encodeURIComponent(String(invoiceId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (include) {
                                localVarQueryParameter['include'] = include;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List Freight Invoice Documents
         * @param {string} invoiceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreightInvoiceDocuments: function (invoiceId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([invoiceId_1], args_1, true), void 0, function (invoiceId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'invoiceId' is not null or undefined
                            (0, common_1.assertParamExists)('getFreightInvoiceDocuments', 'invoiceId', invoiceId);
                            localVarPath = "/freight-invoices/{invoice_id}/documents"
                                .replace("{".concat("invoice_id", "}"), encodeURIComponent(String(invoiceId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Freight Invoice Schema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreightInvoiceSchema: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/private/freight-invoices/schema";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Freight Invoices
         * @param {Array<FreightInvoiceIncludeOptions>} [include]
         * @param {boolean} [excludeDocumentUrls]
         * @param {Array<FreightInvoiceExcludeRelatedEntitiesOptions>} [excludeRelatedEntities]
         * @param {string} [search]
         * @param {string} [orderBy]
         * @param {string} [invoiceableId]
         * @param {string} [invoiceableIdIn]
         * @param {FreightInvoiceStatus} [status]
         * @param {string} [statusIn]
         * @param {string} [statusNotIn]
         * @param {string} [invoiceableReferenceNumber]
         * @param {FreightInvoiceSource} [invoiceSource]
         * @param {string} [serviceProviderName]
         * @param {string} [invoiceNumber]
         * @param {string} [createdAtLt]
         * @param {string} [createdAt]
         * @param {string} [updatedAt]
         * @param {string} [totalAmount]
         * @param {string} [dueDate]
         * @param {string} [serviceProviderId]
         * @param {string} [bookingPartyTenantId]
         * @param {string} [remitToName]
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getFreightInvoicesDeprecated: function (include_1, excludeDocumentUrls_1, excludeRelatedEntities_1, search_1, orderBy_1, invoiceableId_1, invoiceableIdIn_1, status_1, statusIn_1, statusNotIn_1, invoiceableReferenceNumber_1, invoiceSource_1, serviceProviderName_1, invoiceNumber_1, createdAtLt_1, createdAt_1, updatedAt_1, totalAmount_1, dueDate_1, serviceProviderId_1, bookingPartyTenantId_1, remitToName_1, page_1, limit_1) {
            var args_1 = [];
            for (var _i = 24; _i < arguments.length; _i++) {
                args_1[_i - 24] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([include_1, excludeDocumentUrls_1, excludeRelatedEntities_1, search_1, orderBy_1, invoiceableId_1, invoiceableIdIn_1, status_1, statusIn_1, statusNotIn_1, invoiceableReferenceNumber_1, invoiceSource_1, serviceProviderName_1, invoiceNumber_1, createdAtLt_1, createdAt_1, updatedAt_1, totalAmount_1, dueDate_1, serviceProviderId_1, bookingPartyTenantId_1, remitToName_1, page_1, limit_1], args_1, true), void 0, function (include, excludeDocumentUrls, excludeRelatedEntities, search, orderBy, invoiceableId, invoiceableIdIn, status, statusIn, statusNotIn, invoiceableReferenceNumber, invoiceSource, serviceProviderName, invoiceNumber, createdAtLt, createdAt, updatedAt, totalAmount, dueDate, serviceProviderId, bookingPartyTenantId, remitToName, page, limit, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/freight/invoices";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (include) {
                                localVarQueryParameter['include'] = include;
                            }
                            if (excludeDocumentUrls !== undefined) {
                                localVarQueryParameter['exclude_document_urls'] = excludeDocumentUrls;
                            }
                            if (excludeRelatedEntities) {
                                localVarQueryParameter['exclude_related_entities'] = excludeRelatedEntities;
                            }
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            if (orderBy !== undefined) {
                                localVarQueryParameter['order_by'] = orderBy;
                            }
                            if (invoiceableId !== undefined) {
                                localVarQueryParameter['invoiceable_id'] = invoiceableId;
                            }
                            if (invoiceableIdIn !== undefined) {
                                localVarQueryParameter['invoiceable_id__in'] = invoiceableIdIn;
                            }
                            if (status !== undefined) {
                                localVarQueryParameter['status'] = status;
                            }
                            if (statusIn !== undefined) {
                                localVarQueryParameter['status__in'] = statusIn;
                            }
                            if (statusNotIn !== undefined) {
                                localVarQueryParameter['status__not_in'] = statusNotIn;
                            }
                            if (invoiceableReferenceNumber !== undefined) {
                                localVarQueryParameter['invoiceable_reference_number'] = invoiceableReferenceNumber;
                            }
                            if (invoiceSource !== undefined) {
                                localVarQueryParameter['invoice_source'] = invoiceSource;
                            }
                            if (serviceProviderName !== undefined) {
                                localVarQueryParameter['service_provider_name'] = serviceProviderName;
                            }
                            if (invoiceNumber !== undefined) {
                                localVarQueryParameter['invoice_number'] = invoiceNumber;
                            }
                            if (createdAtLt !== undefined) {
                                localVarQueryParameter['created_at__lt'] = (createdAtLt instanceof Date) ?
                                    createdAtLt.toISOString() :
                                    createdAtLt;
                            }
                            if (createdAt !== undefined) {
                                localVarQueryParameter['created_at'] = (createdAt instanceof Date) ?
                                    createdAt.toISOString() :
                                    createdAt;
                            }
                            if (updatedAt !== undefined) {
                                localVarQueryParameter['updated_at'] = (updatedAt instanceof Date) ?
                                    updatedAt.toISOString() :
                                    updatedAt;
                            }
                            if (totalAmount !== undefined) {
                                localVarQueryParameter['total_amount'] = totalAmount;
                            }
                            if (dueDate !== undefined) {
                                localVarQueryParameter['due_date'] = (dueDate instanceof Date) ?
                                    dueDate.toISOString().substring(0, 10) :
                                    dueDate;
                            }
                            if (serviceProviderId !== undefined) {
                                localVarQueryParameter['service_provider_id'] = serviceProviderId;
                            }
                            if (bookingPartyTenantId !== undefined) {
                                localVarQueryParameter['booking_party_tenant_id'] = bookingPartyTenantId;
                            }
                            if (remitToName !== undefined) {
                                localVarQueryParameter['remit_to__name'] = remitToName;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List Freight Invoices
         * @param {Array<FreightInvoiceIncludeOptions>} [include]
         * @param {string} [search]
         * @param {string} [orderBy]
         * @param {string} [invoiceableId]
         * @param {string} [invoiceableIdIn]
         * @param {FreightInvoiceStatus} [status]
         * @param {string} [statusIn]
         * @param {string} [statusNotIn]
         * @param {string} [invoiceableReferenceNumber]
         * @param {FreightInvoiceSource} [invoiceSource]
         * @param {string} [serviceProviderName]
         * @param {string} [invoiceNumber]
         * @param {string} [createdAtLt]
         * @param {string} [createdAt]
         * @param {string} [updatedAt]
         * @param {string} [totalAmount]
         * @param {string} [dueDate]
         * @param {RoleType} [role]
         * @param {string} [remitToName]
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFreightInvoices: function (include_1, search_1, orderBy_1, invoiceableId_1, invoiceableIdIn_1, status_1, statusIn_1, statusNotIn_1, invoiceableReferenceNumber_1, invoiceSource_1, serviceProviderName_1, invoiceNumber_1, createdAtLt_1, createdAt_1, updatedAt_1, totalAmount_1, dueDate_1, role_1, remitToName_1, page_1, limit_1) {
            var args_1 = [];
            for (var _i = 21; _i < arguments.length; _i++) {
                args_1[_i - 21] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([include_1, search_1, orderBy_1, invoiceableId_1, invoiceableIdIn_1, status_1, statusIn_1, statusNotIn_1, invoiceableReferenceNumber_1, invoiceSource_1, serviceProviderName_1, invoiceNumber_1, createdAtLt_1, createdAt_1, updatedAt_1, totalAmount_1, dueDate_1, role_1, remitToName_1, page_1, limit_1], args_1, true), void 0, function (include, search, orderBy, invoiceableId, invoiceableIdIn, status, statusIn, statusNotIn, invoiceableReferenceNumber, invoiceSource, serviceProviderName, invoiceNumber, createdAtLt, createdAt, updatedAt, totalAmount, dueDate, role, remitToName, page, limit, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/freight-invoices";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (include) {
                                localVarQueryParameter['include'] = include;
                            }
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            if (orderBy !== undefined) {
                                localVarQueryParameter['order_by'] = orderBy;
                            }
                            if (invoiceableId !== undefined) {
                                localVarQueryParameter['invoiceable_id'] = invoiceableId;
                            }
                            if (invoiceableIdIn !== undefined) {
                                localVarQueryParameter['invoiceable_id__in'] = invoiceableIdIn;
                            }
                            if (status !== undefined) {
                                localVarQueryParameter['status'] = status;
                            }
                            if (statusIn !== undefined) {
                                localVarQueryParameter['status__in'] = statusIn;
                            }
                            if (statusNotIn !== undefined) {
                                localVarQueryParameter['status__not_in'] = statusNotIn;
                            }
                            if (invoiceableReferenceNumber !== undefined) {
                                localVarQueryParameter['invoiceable_reference_number'] = invoiceableReferenceNumber;
                            }
                            if (invoiceSource !== undefined) {
                                localVarQueryParameter['invoice_source'] = invoiceSource;
                            }
                            if (serviceProviderName !== undefined) {
                                localVarQueryParameter['service_provider_name'] = serviceProviderName;
                            }
                            if (invoiceNumber !== undefined) {
                                localVarQueryParameter['invoice_number'] = invoiceNumber;
                            }
                            if (createdAtLt !== undefined) {
                                localVarQueryParameter['created_at__lt'] = (createdAtLt instanceof Date) ?
                                    createdAtLt.toISOString() :
                                    createdAtLt;
                            }
                            if (createdAt !== undefined) {
                                localVarQueryParameter['created_at'] = (createdAt instanceof Date) ?
                                    createdAt.toISOString() :
                                    createdAt;
                            }
                            if (updatedAt !== undefined) {
                                localVarQueryParameter['updated_at'] = (updatedAt instanceof Date) ?
                                    updatedAt.toISOString() :
                                    updatedAt;
                            }
                            if (totalAmount !== undefined) {
                                localVarQueryParameter['total_amount'] = totalAmount;
                            }
                            if (dueDate !== undefined) {
                                localVarQueryParameter['due_date'] = (dueDate instanceof Date) ?
                                    dueDate.toISOString().substring(0, 10) :
                                    dueDate;
                            }
                            if (role !== undefined) {
                                localVarQueryParameter['role'] = role;
                            }
                            if (remitToName !== undefined) {
                                localVarQueryParameter['remit_to__name'] = remitToName;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Freight Invoice Document
         * @param {string} invoiceId
         * @param {string} documentId
         * @param {DocumentMetadata} documentMetadata
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFreightInvoiceDocument: function (invoiceId_1, documentId_1, documentMetadata_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([invoiceId_1, documentId_1, documentMetadata_1], args_1, true), void 0, function (invoiceId, documentId, documentMetadata, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'invoiceId' is not null or undefined
                            (0, common_1.assertParamExists)('updateFreightInvoiceDocument', 'invoiceId', invoiceId);
                            // verify required parameter 'documentId' is not null or undefined
                            (0, common_1.assertParamExists)('updateFreightInvoiceDocument', 'documentId', documentId);
                            // verify required parameter 'documentMetadata' is not null or undefined
                            (0, common_1.assertParamExists)('updateFreightInvoiceDocument', 'documentMetadata', documentMetadata);
                            localVarPath = "/freight-invoices/{invoice_id}/documents/{document_id}"
                                .replace("{".concat("invoice_id", "}"), encodeURIComponent(String(invoiceId)))
                                .replace("{".concat("document_id", "}"), encodeURIComponent(String(documentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(documentMetadata, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update the `status` of a Freight Invoice. Navigate to      [this guide](/docs/shipments/freight-invoices/#update-the-status-of-a-freight-invoice) to learn about the      available state transitions for Freight Invoice Status.
         * @summary Update Freight Invoice Status
         * @param {string} invoiceId
         * @param {UpdateFreightInvoiceStatus} updateFreightInvoiceStatus
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFreightInvoiceStatus: function (invoiceId_1, updateFreightInvoiceStatus_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([invoiceId_1, updateFreightInvoiceStatus_1], args_1, true), void 0, function (invoiceId, updateFreightInvoiceStatus, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'invoiceId' is not null or undefined
                            (0, common_1.assertParamExists)('updateFreightInvoiceStatus', 'invoiceId', invoiceId);
                            // verify required parameter 'updateFreightInvoiceStatus' is not null or undefined
                            (0, common_1.assertParamExists)('updateFreightInvoiceStatus', 'updateFreightInvoiceStatus', updateFreightInvoiceStatus);
                            localVarPath = "/freight-invoices/{invoice_id}/status"
                                .replace("{".concat("invoice_id", "}"), encodeURIComponent(String(invoiceId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateFreightInvoiceStatus, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update the `status` of a Freight Invoice. Navigate to      [this guide](/docs/shipments/freight-invoices/#update-the-status-of-a-freight-invoice) to learn about the      available state transitions for Freight Invoice Status.
         * @summary Update Freight Invoice Status
         * @param {string} invoiceId
         * @param {UpdateFreightInvoiceStatus} updateFreightInvoiceStatus
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        updateFreightInvoiceStatusDeprecated: function (invoiceId_1, updateFreightInvoiceStatus_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([invoiceId_1, updateFreightInvoiceStatus_1], args_1, true), void 0, function (invoiceId, updateFreightInvoiceStatus, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'invoiceId' is not null or undefined
                            (0, common_1.assertParamExists)('updateFreightInvoiceStatusDeprecated', 'invoiceId', invoiceId);
                            // verify required parameter 'updateFreightInvoiceStatus' is not null or undefined
                            (0, common_1.assertParamExists)('updateFreightInvoiceStatusDeprecated', 'updateFreightInvoiceStatus', updateFreightInvoiceStatus);
                            localVarPath = "/freight/invoices/{invoice_id}/status"
                                .replace("{".concat("invoice_id", "}"), encodeURIComponent(String(invoiceId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateFreightInvoiceStatus, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.FreightInvoicesApiAxiosParamCreator = FreightInvoicesApiAxiosParamCreator;
/**
 * FreightInvoicesApi - functional programming interface
 * @export
 */
var FreightInvoicesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.FreightInvoicesApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Create Freight Invoice
         * @param {CreateFreightInvoice} data
         * @param {CreateFreightInvoiceDocument} [documentsMetadata]
         * @param {Array<File>} [documents]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFreightInvoice: function (data, documentsMetadata, documents, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createFreightInvoice(data, documentsMetadata, documents, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FreightInvoicesApi.createFreightInvoice']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Freight Invoice
         * @param {CreateFreightInvoice} data
         * @param {CreateFreightInvoiceDocument} [documentsMetadata]
         * @param {Array<File>} [documents]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        createFreightInvoiceDeprecated: function (data, documentsMetadata, documents, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createFreightInvoiceDeprecated(data, documentsMetadata, documents, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FreightInvoicesApi.createFreightInvoiceDeprecated']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Create or attach one or more Freight Invoice Documents to an existing Freight Invoice. Navigate to      [this guide](/docs/shipments/freight-invoices/) to learn how to create a Freight Invoice from a Shipment.
         * @summary Create Freight Invoice Document
         * @param {string} invoiceId
         * @param {CreateFreightInvoiceDocument} [documentsMetadata]
         * @param {Array<File>} [documents]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFreightInvoiceDocument: function (invoiceId, documentsMetadata, documents, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createFreightInvoiceDocument(invoiceId, documentsMetadata, documents, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FreightInvoicesApi.createFreightInvoiceDocument']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Freight Invoice
         * @param {string} invoiceId
         * @param {Array<FreightInvoiceIncludeOptions>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreightInvoice: function (invoiceId, include, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFreightInvoice(invoiceId, include, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FreightInvoicesApi.getFreightInvoice']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Freight Invoice
         * @param {string} invoiceId
         * @param {Array<FreightInvoiceIncludeOptions>} [include]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getFreightInvoiceDeprecated: function (invoiceId, include, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFreightInvoiceDeprecated(invoiceId, include, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FreightInvoicesApi.getFreightInvoiceDeprecated']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary List Freight Invoice Documents
         * @param {string} invoiceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreightInvoiceDocuments: function (invoiceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFreightInvoiceDocuments(invoiceId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FreightInvoicesApi.getFreightInvoiceDocuments']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Freight Invoice Schema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreightInvoiceSchema: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFreightInvoiceSchema(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FreightInvoicesApi.getFreightInvoiceSchema']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Freight Invoices
         * @param {Array<FreightInvoiceIncludeOptions>} [include]
         * @param {boolean} [excludeDocumentUrls]
         * @param {Array<FreightInvoiceExcludeRelatedEntitiesOptions>} [excludeRelatedEntities]
         * @param {string} [search]
         * @param {string} [orderBy]
         * @param {string} [invoiceableId]
         * @param {string} [invoiceableIdIn]
         * @param {FreightInvoiceStatus} [status]
         * @param {string} [statusIn]
         * @param {string} [statusNotIn]
         * @param {string} [invoiceableReferenceNumber]
         * @param {FreightInvoiceSource} [invoiceSource]
         * @param {string} [serviceProviderName]
         * @param {string} [invoiceNumber]
         * @param {string} [createdAtLt]
         * @param {string} [createdAt]
         * @param {string} [updatedAt]
         * @param {string} [totalAmount]
         * @param {string} [dueDate]
         * @param {string} [serviceProviderId]
         * @param {string} [bookingPartyTenantId]
         * @param {string} [remitToName]
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getFreightInvoicesDeprecated: function (include, excludeDocumentUrls, excludeRelatedEntities, search, orderBy, invoiceableId, invoiceableIdIn, status, statusIn, statusNotIn, invoiceableReferenceNumber, invoiceSource, serviceProviderName, invoiceNumber, createdAtLt, createdAt, updatedAt, totalAmount, dueDate, serviceProviderId, bookingPartyTenantId, remitToName, page, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFreightInvoicesDeprecated(include, excludeDocumentUrls, excludeRelatedEntities, search, orderBy, invoiceableId, invoiceableIdIn, status, statusIn, statusNotIn, invoiceableReferenceNumber, invoiceSource, serviceProviderName, invoiceNumber, createdAtLt, createdAt, updatedAt, totalAmount, dueDate, serviceProviderId, bookingPartyTenantId, remitToName, page, limit, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FreightInvoicesApi.getFreightInvoicesDeprecated']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary List Freight Invoices
         * @param {Array<FreightInvoiceIncludeOptions>} [include]
         * @param {string} [search]
         * @param {string} [orderBy]
         * @param {string} [invoiceableId]
         * @param {string} [invoiceableIdIn]
         * @param {FreightInvoiceStatus} [status]
         * @param {string} [statusIn]
         * @param {string} [statusNotIn]
         * @param {string} [invoiceableReferenceNumber]
         * @param {FreightInvoiceSource} [invoiceSource]
         * @param {string} [serviceProviderName]
         * @param {string} [invoiceNumber]
         * @param {string} [createdAtLt]
         * @param {string} [createdAt]
         * @param {string} [updatedAt]
         * @param {string} [totalAmount]
         * @param {string} [dueDate]
         * @param {RoleType} [role]
         * @param {string} [remitToName]
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFreightInvoices: function (include, search, orderBy, invoiceableId, invoiceableIdIn, status, statusIn, statusNotIn, invoiceableReferenceNumber, invoiceSource, serviceProviderName, invoiceNumber, createdAtLt, createdAt, updatedAt, totalAmount, dueDate, role, remitToName, page, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listFreightInvoices(include, search, orderBy, invoiceableId, invoiceableIdIn, status, statusIn, statusNotIn, invoiceableReferenceNumber, invoiceSource, serviceProviderName, invoiceNumber, createdAtLt, createdAt, updatedAt, totalAmount, dueDate, role, remitToName, page, limit, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FreightInvoicesApi.listFreightInvoices']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Freight Invoice Document
         * @param {string} invoiceId
         * @param {string} documentId
         * @param {DocumentMetadata} documentMetadata
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFreightInvoiceDocument: function (invoiceId, documentId, documentMetadata, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateFreightInvoiceDocument(invoiceId, documentId, documentMetadata, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FreightInvoicesApi.updateFreightInvoiceDocument']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Update the `status` of a Freight Invoice. Navigate to      [this guide](/docs/shipments/freight-invoices/#update-the-status-of-a-freight-invoice) to learn about the      available state transitions for Freight Invoice Status.
         * @summary Update Freight Invoice Status
         * @param {string} invoiceId
         * @param {UpdateFreightInvoiceStatus} updateFreightInvoiceStatus
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFreightInvoiceStatus: function (invoiceId, updateFreightInvoiceStatus, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateFreightInvoiceStatus(invoiceId, updateFreightInvoiceStatus, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FreightInvoicesApi.updateFreightInvoiceStatus']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Update the `status` of a Freight Invoice. Navigate to      [this guide](/docs/shipments/freight-invoices/#update-the-status-of-a-freight-invoice) to learn about the      available state transitions for Freight Invoice Status.
         * @summary Update Freight Invoice Status
         * @param {string} invoiceId
         * @param {UpdateFreightInvoiceStatus} updateFreightInvoiceStatus
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        updateFreightInvoiceStatusDeprecated: function (invoiceId, updateFreightInvoiceStatus, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateFreightInvoiceStatusDeprecated(invoiceId, updateFreightInvoiceStatus, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FreightInvoicesApi.updateFreightInvoiceStatusDeprecated']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.FreightInvoicesApiFp = FreightInvoicesApiFp;
/**
 * FreightInvoicesApi - factory interface
 * @export
 */
var FreightInvoicesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.FreightInvoicesApiFp)(configuration);
    return {
        /**
         *
         * @summary Create Freight Invoice
         * @param {FreightInvoicesApiCreateFreightInvoiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFreightInvoice: function (requestParameters, options) {
            return localVarFp.createFreightInvoice(requestParameters.data, requestParameters.documentsMetadata, requestParameters.documents, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create Freight Invoice
         * @param {FreightInvoicesApiCreateFreightInvoiceDeprecatedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        createFreightInvoiceDeprecated: function (requestParameters, options) {
            return localVarFp.createFreightInvoiceDeprecated(requestParameters.data, requestParameters.documentsMetadata, requestParameters.documents, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create or attach one or more Freight Invoice Documents to an existing Freight Invoice. Navigate to      [this guide](/docs/shipments/freight-invoices/) to learn how to create a Freight Invoice from a Shipment.
         * @summary Create Freight Invoice Document
         * @param {FreightInvoicesApiCreateFreightInvoiceDocumentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFreightInvoiceDocument: function (requestParameters, options) {
            return localVarFp.createFreightInvoiceDocument(requestParameters.invoiceId, requestParameters.documentsMetadata, requestParameters.documents, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Freight Invoice
         * @param {FreightInvoicesApiGetFreightInvoiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreightInvoice: function (requestParameters, options) {
            return localVarFp.getFreightInvoice(requestParameters.invoiceId, requestParameters.include, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Freight Invoice
         * @param {FreightInvoicesApiGetFreightInvoiceDeprecatedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getFreightInvoiceDeprecated: function (requestParameters, options) {
            return localVarFp.getFreightInvoiceDeprecated(requestParameters.invoiceId, requestParameters.include, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List Freight Invoice Documents
         * @param {FreightInvoicesApiGetFreightInvoiceDocumentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreightInvoiceDocuments: function (requestParameters, options) {
            return localVarFp.getFreightInvoiceDocuments(requestParameters.invoiceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Freight Invoice Schema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreightInvoiceSchema: function (options) {
            return localVarFp.getFreightInvoiceSchema(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Freight Invoices
         * @param {FreightInvoicesApiGetFreightInvoicesDeprecatedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getFreightInvoicesDeprecated: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.getFreightInvoicesDeprecated(requestParameters.include, requestParameters.excludeDocumentUrls, requestParameters.excludeRelatedEntities, requestParameters.search, requestParameters.orderBy, requestParameters.invoiceableId, requestParameters.invoiceableIdIn, requestParameters.status, requestParameters.statusIn, requestParameters.statusNotIn, requestParameters.invoiceableReferenceNumber, requestParameters.invoiceSource, requestParameters.serviceProviderName, requestParameters.invoiceNumber, requestParameters.createdAtLt, requestParameters.createdAt, requestParameters.updatedAt, requestParameters.totalAmount, requestParameters.dueDate, requestParameters.serviceProviderId, requestParameters.bookingPartyTenantId, requestParameters.remitToName, requestParameters.page, requestParameters.limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List Freight Invoices
         * @param {FreightInvoicesApiListFreightInvoicesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFreightInvoices: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.listFreightInvoices(requestParameters.include, requestParameters.search, requestParameters.orderBy, requestParameters.invoiceableId, requestParameters.invoiceableIdIn, requestParameters.status, requestParameters.statusIn, requestParameters.statusNotIn, requestParameters.invoiceableReferenceNumber, requestParameters.invoiceSource, requestParameters.serviceProviderName, requestParameters.invoiceNumber, requestParameters.createdAtLt, requestParameters.createdAt, requestParameters.updatedAt, requestParameters.totalAmount, requestParameters.dueDate, requestParameters.role, requestParameters.remitToName, requestParameters.page, requestParameters.limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Freight Invoice Document
         * @param {FreightInvoicesApiUpdateFreightInvoiceDocumentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFreightInvoiceDocument: function (requestParameters, options) {
            return localVarFp.updateFreightInvoiceDocument(requestParameters.invoiceId, requestParameters.documentId, requestParameters.documentMetadata, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update the `status` of a Freight Invoice. Navigate to      [this guide](/docs/shipments/freight-invoices/#update-the-status-of-a-freight-invoice) to learn about the      available state transitions for Freight Invoice Status.
         * @summary Update Freight Invoice Status
         * @param {FreightInvoicesApiUpdateFreightInvoiceStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFreightInvoiceStatus: function (requestParameters, options) {
            return localVarFp.updateFreightInvoiceStatus(requestParameters.invoiceId, requestParameters.updateFreightInvoiceStatus, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update the `status` of a Freight Invoice. Navigate to      [this guide](/docs/shipments/freight-invoices/#update-the-status-of-a-freight-invoice) to learn about the      available state transitions for Freight Invoice Status.
         * @summary Update Freight Invoice Status
         * @param {FreightInvoicesApiUpdateFreightInvoiceStatusDeprecatedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        updateFreightInvoiceStatusDeprecated: function (requestParameters, options) {
            return localVarFp.updateFreightInvoiceStatusDeprecated(requestParameters.invoiceId, requestParameters.updateFreightInvoiceStatus, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.FreightInvoicesApiFactory = FreightInvoicesApiFactory;
/**
 * FreightInvoicesApi - object-oriented interface
 * @export
 * @class FreightInvoicesApi
 * @extends {BaseAPI}
 */
var FreightInvoicesApi = /** @class */ (function (_super) {
    __extends(FreightInvoicesApi, _super);
    function FreightInvoicesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Create Freight Invoice
     * @param {FreightInvoicesApiCreateFreightInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FreightInvoicesApi
     */
    FreightInvoicesApi.prototype.createFreightInvoice = function (requestParameters, options) {
        var _this = this;
        return (0, exports.FreightInvoicesApiFp)(this.configuration).createFreightInvoice(requestParameters.data, requestParameters.documentsMetadata, requestParameters.documents, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create Freight Invoice
     * @param {FreightInvoicesApiCreateFreightInvoiceDeprecatedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof FreightInvoicesApi
     */
    FreightInvoicesApi.prototype.createFreightInvoiceDeprecated = function (requestParameters, options) {
        var _this = this;
        return (0, exports.FreightInvoicesApiFp)(this.configuration).createFreightInvoiceDeprecated(requestParameters.data, requestParameters.documentsMetadata, requestParameters.documents, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create or attach one or more Freight Invoice Documents to an existing Freight Invoice. Navigate to      [this guide](/docs/shipments/freight-invoices/) to learn how to create a Freight Invoice from a Shipment.
     * @summary Create Freight Invoice Document
     * @param {FreightInvoicesApiCreateFreightInvoiceDocumentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FreightInvoicesApi
     */
    FreightInvoicesApi.prototype.createFreightInvoiceDocument = function (requestParameters, options) {
        var _this = this;
        return (0, exports.FreightInvoicesApiFp)(this.configuration).createFreightInvoiceDocument(requestParameters.invoiceId, requestParameters.documentsMetadata, requestParameters.documents, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Freight Invoice
     * @param {FreightInvoicesApiGetFreightInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FreightInvoicesApi
     */
    FreightInvoicesApi.prototype.getFreightInvoice = function (requestParameters, options) {
        var _this = this;
        return (0, exports.FreightInvoicesApiFp)(this.configuration).getFreightInvoice(requestParameters.invoiceId, requestParameters.include, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Freight Invoice
     * @param {FreightInvoicesApiGetFreightInvoiceDeprecatedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof FreightInvoicesApi
     */
    FreightInvoicesApi.prototype.getFreightInvoiceDeprecated = function (requestParameters, options) {
        var _this = this;
        return (0, exports.FreightInvoicesApiFp)(this.configuration).getFreightInvoiceDeprecated(requestParameters.invoiceId, requestParameters.include, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List Freight Invoice Documents
     * @param {FreightInvoicesApiGetFreightInvoiceDocumentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FreightInvoicesApi
     */
    FreightInvoicesApi.prototype.getFreightInvoiceDocuments = function (requestParameters, options) {
        var _this = this;
        return (0, exports.FreightInvoicesApiFp)(this.configuration).getFreightInvoiceDocuments(requestParameters.invoiceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Freight Invoice Schema
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FreightInvoicesApi
     */
    FreightInvoicesApi.prototype.getFreightInvoiceSchema = function (options) {
        var _this = this;
        return (0, exports.FreightInvoicesApiFp)(this.configuration).getFreightInvoiceSchema(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Freight Invoices
     * @param {FreightInvoicesApiGetFreightInvoicesDeprecatedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof FreightInvoicesApi
     */
    FreightInvoicesApi.prototype.getFreightInvoicesDeprecated = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.FreightInvoicesApiFp)(this.configuration).getFreightInvoicesDeprecated(requestParameters.include, requestParameters.excludeDocumentUrls, requestParameters.excludeRelatedEntities, requestParameters.search, requestParameters.orderBy, requestParameters.invoiceableId, requestParameters.invoiceableIdIn, requestParameters.status, requestParameters.statusIn, requestParameters.statusNotIn, requestParameters.invoiceableReferenceNumber, requestParameters.invoiceSource, requestParameters.serviceProviderName, requestParameters.invoiceNumber, requestParameters.createdAtLt, requestParameters.createdAt, requestParameters.updatedAt, requestParameters.totalAmount, requestParameters.dueDate, requestParameters.serviceProviderId, requestParameters.bookingPartyTenantId, requestParameters.remitToName, requestParameters.page, requestParameters.limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List Freight Invoices
     * @param {FreightInvoicesApiListFreightInvoicesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FreightInvoicesApi
     */
    FreightInvoicesApi.prototype.listFreightInvoices = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.FreightInvoicesApiFp)(this.configuration).listFreightInvoices(requestParameters.include, requestParameters.search, requestParameters.orderBy, requestParameters.invoiceableId, requestParameters.invoiceableIdIn, requestParameters.status, requestParameters.statusIn, requestParameters.statusNotIn, requestParameters.invoiceableReferenceNumber, requestParameters.invoiceSource, requestParameters.serviceProviderName, requestParameters.invoiceNumber, requestParameters.createdAtLt, requestParameters.createdAt, requestParameters.updatedAt, requestParameters.totalAmount, requestParameters.dueDate, requestParameters.role, requestParameters.remitToName, requestParameters.page, requestParameters.limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Freight Invoice Document
     * @param {FreightInvoicesApiUpdateFreightInvoiceDocumentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FreightInvoicesApi
     */
    FreightInvoicesApi.prototype.updateFreightInvoiceDocument = function (requestParameters, options) {
        var _this = this;
        return (0, exports.FreightInvoicesApiFp)(this.configuration).updateFreightInvoiceDocument(requestParameters.invoiceId, requestParameters.documentId, requestParameters.documentMetadata, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update the `status` of a Freight Invoice. Navigate to      [this guide](/docs/shipments/freight-invoices/#update-the-status-of-a-freight-invoice) to learn about the      available state transitions for Freight Invoice Status.
     * @summary Update Freight Invoice Status
     * @param {FreightInvoicesApiUpdateFreightInvoiceStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FreightInvoicesApi
     */
    FreightInvoicesApi.prototype.updateFreightInvoiceStatus = function (requestParameters, options) {
        var _this = this;
        return (0, exports.FreightInvoicesApiFp)(this.configuration).updateFreightInvoiceStatus(requestParameters.invoiceId, requestParameters.updateFreightInvoiceStatus, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update the `status` of a Freight Invoice. Navigate to      [this guide](/docs/shipments/freight-invoices/#update-the-status-of-a-freight-invoice) to learn about the      available state transitions for Freight Invoice Status.
     * @summary Update Freight Invoice Status
     * @param {FreightInvoicesApiUpdateFreightInvoiceStatusDeprecatedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof FreightInvoicesApi
     */
    FreightInvoicesApi.prototype.updateFreightInvoiceStatusDeprecated = function (requestParameters, options) {
        var _this = this;
        return (0, exports.FreightInvoicesApiFp)(this.configuration).updateFreightInvoiceStatusDeprecated(requestParameters.invoiceId, requestParameters.updateFreightInvoiceStatus, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return FreightInvoicesApi;
}(base_1.BaseAPI));
exports.FreightInvoicesApi = FreightInvoicesApi;
/**
 * FreightSettlementsConfigurationsApi - axios parameter creator
 * @export
 */
var FreightSettlementsConfigurationsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Bulk Update Freight Configurations Status
         * @param {Array<UpdateFreightSettlementsConfigurationStatus>} updateFreightSettlementsConfigurationStatus
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateFreightConfigurationsStatus: function (updateFreightSettlementsConfigurationStatus_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([updateFreightSettlementsConfigurationStatus_1], args_1, true), void 0, function (updateFreightSettlementsConfigurationStatus, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'updateFreightSettlementsConfigurationStatus' is not null or undefined
                            (0, common_1.assertParamExists)('bulkUpdateFreightConfigurationsStatus', 'updateFreightSettlementsConfigurationStatus', updateFreightSettlementsConfigurationStatus);
                            localVarPath = "/freight-invoices/configurations/status-update";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateFreightSettlementsConfigurationStatus, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Freight Configuration
         * @param {string} freightConfigurationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreightConfiguration: function (freightConfigurationId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([freightConfigurationId_1], args_1, true), void 0, function (freightConfigurationId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'freightConfigurationId' is not null or undefined
                            (0, common_1.assertParamExists)('getFreightConfiguration', 'freightConfigurationId', freightConfigurationId);
                            localVarPath = "/freight-invoices/configurations/{freight_configuration_id}"
                                .replace("{".concat("freight_configuration_id", "}"), encodeURIComponent(String(freightConfigurationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List Freight Configurations
         * @param {string} [bookingPartyId]
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFreightConfigurations: function (bookingPartyId_1, page_1, limit_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([bookingPartyId_1, page_1, limit_1], args_1, true), void 0, function (bookingPartyId, page, limit, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/freight-invoices/configurations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (bookingPartyId !== undefined) {
                                localVarQueryParameter['booking_party_id'] = bookingPartyId;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Freight Configuration
         * @param {string} freightConfigurationId
         * @param {UpdateSettlementsConfig} updateSettlementsConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFreightConfiguration: function (freightConfigurationId_1, updateSettlementsConfig_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([freightConfigurationId_1, updateSettlementsConfig_1], args_1, true), void 0, function (freightConfigurationId, updateSettlementsConfig, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'freightConfigurationId' is not null or undefined
                            (0, common_1.assertParamExists)('updateFreightConfiguration', 'freightConfigurationId', freightConfigurationId);
                            // verify required parameter 'updateSettlementsConfig' is not null or undefined
                            (0, common_1.assertParamExists)('updateFreightConfiguration', 'updateSettlementsConfig', updateSettlementsConfig);
                            localVarPath = "/freight-invoices/configurations/{freight_configuration_id}"
                                .replace("{".concat("freight_configuration_id", "}"), encodeURIComponent(String(freightConfigurationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateSettlementsConfig, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.FreightSettlementsConfigurationsApiAxiosParamCreator = FreightSettlementsConfigurationsApiAxiosParamCreator;
/**
 * FreightSettlementsConfigurationsApi - functional programming interface
 * @export
 */
var FreightSettlementsConfigurationsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.FreightSettlementsConfigurationsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Bulk Update Freight Configurations Status
         * @param {Array<UpdateFreightSettlementsConfigurationStatus>} updateFreightSettlementsConfigurationStatus
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateFreightConfigurationsStatus: function (updateFreightSettlementsConfigurationStatus, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.bulkUpdateFreightConfigurationsStatus(updateFreightSettlementsConfigurationStatus, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FreightSettlementsConfigurationsApi.bulkUpdateFreightConfigurationsStatus']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Freight Configuration
         * @param {string} freightConfigurationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreightConfiguration: function (freightConfigurationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFreightConfiguration(freightConfigurationId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FreightSettlementsConfigurationsApi.getFreightConfiguration']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary List Freight Configurations
         * @param {string} [bookingPartyId]
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFreightConfigurations: function (bookingPartyId, page, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listFreightConfigurations(bookingPartyId, page, limit, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FreightSettlementsConfigurationsApi.listFreightConfigurations']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Freight Configuration
         * @param {string} freightConfigurationId
         * @param {UpdateSettlementsConfig} updateSettlementsConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFreightConfiguration: function (freightConfigurationId, updateSettlementsConfig, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateFreightConfiguration(freightConfigurationId, updateSettlementsConfig, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FreightSettlementsConfigurationsApi.updateFreightConfiguration']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.FreightSettlementsConfigurationsApiFp = FreightSettlementsConfigurationsApiFp;
/**
 * FreightSettlementsConfigurationsApi - factory interface
 * @export
 */
var FreightSettlementsConfigurationsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.FreightSettlementsConfigurationsApiFp)(configuration);
    return {
        /**
         *
         * @summary Bulk Update Freight Configurations Status
         * @param {FreightSettlementsConfigurationsApiBulkUpdateFreightConfigurationsStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateFreightConfigurationsStatus: function (requestParameters, options) {
            return localVarFp.bulkUpdateFreightConfigurationsStatus(requestParameters.updateFreightSettlementsConfigurationStatus, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Freight Configuration
         * @param {FreightSettlementsConfigurationsApiGetFreightConfigurationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreightConfiguration: function (requestParameters, options) {
            return localVarFp.getFreightConfiguration(requestParameters.freightConfigurationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List Freight Configurations
         * @param {FreightSettlementsConfigurationsApiListFreightConfigurationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFreightConfigurations: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.listFreightConfigurations(requestParameters.bookingPartyId, requestParameters.page, requestParameters.limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Freight Configuration
         * @param {FreightSettlementsConfigurationsApiUpdateFreightConfigurationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFreightConfiguration: function (requestParameters, options) {
            return localVarFp.updateFreightConfiguration(requestParameters.freightConfigurationId, requestParameters.updateSettlementsConfig, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.FreightSettlementsConfigurationsApiFactory = FreightSettlementsConfigurationsApiFactory;
/**
 * FreightSettlementsConfigurationsApi - object-oriented interface
 * @export
 * @class FreightSettlementsConfigurationsApi
 * @extends {BaseAPI}
 */
var FreightSettlementsConfigurationsApi = /** @class */ (function (_super) {
    __extends(FreightSettlementsConfigurationsApi, _super);
    function FreightSettlementsConfigurationsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Bulk Update Freight Configurations Status
     * @param {FreightSettlementsConfigurationsApiBulkUpdateFreightConfigurationsStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FreightSettlementsConfigurationsApi
     */
    FreightSettlementsConfigurationsApi.prototype.bulkUpdateFreightConfigurationsStatus = function (requestParameters, options) {
        var _this = this;
        return (0, exports.FreightSettlementsConfigurationsApiFp)(this.configuration).bulkUpdateFreightConfigurationsStatus(requestParameters.updateFreightSettlementsConfigurationStatus, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Freight Configuration
     * @param {FreightSettlementsConfigurationsApiGetFreightConfigurationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FreightSettlementsConfigurationsApi
     */
    FreightSettlementsConfigurationsApi.prototype.getFreightConfiguration = function (requestParameters, options) {
        var _this = this;
        return (0, exports.FreightSettlementsConfigurationsApiFp)(this.configuration).getFreightConfiguration(requestParameters.freightConfigurationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List Freight Configurations
     * @param {FreightSettlementsConfigurationsApiListFreightConfigurationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FreightSettlementsConfigurationsApi
     */
    FreightSettlementsConfigurationsApi.prototype.listFreightConfigurations = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.FreightSettlementsConfigurationsApiFp)(this.configuration).listFreightConfigurations(requestParameters.bookingPartyId, requestParameters.page, requestParameters.limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Freight Configuration
     * @param {FreightSettlementsConfigurationsApiUpdateFreightConfigurationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FreightSettlementsConfigurationsApi
     */
    FreightSettlementsConfigurationsApi.prototype.updateFreightConfiguration = function (requestParameters, options) {
        var _this = this;
        return (0, exports.FreightSettlementsConfigurationsApiFp)(this.configuration).updateFreightConfiguration(requestParameters.freightConfigurationId, requestParameters.updateSettlementsConfig, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return FreightSettlementsConfigurationsApi;
}(base_1.BaseAPI));
exports.FreightSettlementsConfigurationsApi = FreightSettlementsConfigurationsApi;
/**
 * QuickbooksApi - axios parameter creator
 * @export
 */
var QuickbooksApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Process Webhook Bill Update Request
         * @param {UpdateQuickbooksBill} updateQuickbooksBill
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processWebhookBillUpdateRequest: function (updateQuickbooksBill_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([updateQuickbooksBill_1], args_1, true), void 0, function (updateQuickbooksBill, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'updateQuickbooksBill' is not null or undefined
                            (0, common_1.assertParamExists)('processWebhookBillUpdateRequest', 'updateQuickbooksBill', updateQuickbooksBill);
                            localVarPath = "/integrations/quickbooks/webhooks/billing";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateQuickbooksBill, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Process Webhook Update Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processWebhookUpdateRequest: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/integrations/quickbooks/webhooks";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.QuickbooksApiAxiosParamCreator = QuickbooksApiAxiosParamCreator;
/**
 * QuickbooksApi - functional programming interface
 * @export
 */
var QuickbooksApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.QuickbooksApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Process Webhook Bill Update Request
         * @param {UpdateQuickbooksBill} updateQuickbooksBill
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processWebhookBillUpdateRequest: function (updateQuickbooksBill, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.processWebhookBillUpdateRequest(updateQuickbooksBill, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['QuickbooksApi.processWebhookBillUpdateRequest']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Process Webhook Update Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processWebhookUpdateRequest: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.processWebhookUpdateRequest(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['QuickbooksApi.processWebhookUpdateRequest']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.QuickbooksApiFp = QuickbooksApiFp;
/**
 * QuickbooksApi - factory interface
 * @export
 */
var QuickbooksApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.QuickbooksApiFp)(configuration);
    return {
        /**
         *
         * @summary Process Webhook Bill Update Request
         * @param {QuickbooksApiProcessWebhookBillUpdateRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processWebhookBillUpdateRequest: function (requestParameters, options) {
            return localVarFp.processWebhookBillUpdateRequest(requestParameters.updateQuickbooksBill, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Process Webhook Update Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processWebhookUpdateRequest: function (options) {
            return localVarFp.processWebhookUpdateRequest(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.QuickbooksApiFactory = QuickbooksApiFactory;
/**
 * QuickbooksApi - object-oriented interface
 * @export
 * @class QuickbooksApi
 * @extends {BaseAPI}
 */
var QuickbooksApi = /** @class */ (function (_super) {
    __extends(QuickbooksApi, _super);
    function QuickbooksApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Process Webhook Bill Update Request
     * @param {QuickbooksApiProcessWebhookBillUpdateRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickbooksApi
     */
    QuickbooksApi.prototype.processWebhookBillUpdateRequest = function (requestParameters, options) {
        var _this = this;
        return (0, exports.QuickbooksApiFp)(this.configuration).processWebhookBillUpdateRequest(requestParameters.updateQuickbooksBill, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Process Webhook Update Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickbooksApi
     */
    QuickbooksApi.prototype.processWebhookUpdateRequest = function (options) {
        var _this = this;
        return (0, exports.QuickbooksApiFp)(this.configuration).processWebhookUpdateRequest(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return QuickbooksApi;
}(base_1.BaseAPI));
exports.QuickbooksApi = QuickbooksApi;
